// Web CRM (Business plane) PAGE-BODY i18n dictionary — BATCH B — STATIC UI CHROME ONLY.
// Merged into the flat per-language lookup by ./translations.js (same t() semantics, no new dep).
//
// SCOPE: remaining visible static labels on four Business pages that were only partially
// localized before — Category Manager, Director Dashboard, Executive Dashboard, IT Dashboard.
// NEVER used for dynamic/backend/user content (business/customer names, product data, prices,
// brand IDs, API enums, generated text, metric values). Common buttons/status reuse `common.*`
// and role titles reuse `role.*` — not redefined here.
//
// English is the default + fallback. Every language below carries the IDENTICAL key set.

const pagesCompleteBTranslations = {
  en: {
    // ---- Common ----
    'pcb.common.success': 'Success',
    'pcb.common.cancel': 'Cancel',

    // ---- Category Manager ----
    'pcb.category.notSet': 'Not Set',
    'pcb.category.loadingCategories': 'Loading feedback categories...',
    'pcb.category.industry': 'Industry',
    'pcb.category.subSector': 'Sub-Sector',
    'pcb.category.addCustom': 'Add Custom Category',
    'pcb.category.viewAnalytics': 'View Analytics',
    'pcb.category.totalCategories': 'Total Categories',
    'pcb.category.enabled': 'Enabled',
    'pcb.category.customized': 'Customized',
    'pcb.category.inherited': 'Inherited',
    'pcb.category.universal': 'Universal',
    'pcb.category.custom': 'Custom',
    'pcb.category.activeCategories': 'Active Feedback Categories',
    'pcb.category.activeCategoriesDesc': 'Categories inherited from your sub-sector. Customize priorities, escalation rules, and AI keywords.',
    'pcb.category.noCategories': 'No categories found',
    'pcb.category.noCategoriesHint': 'Complete your business profile to get feedback categories assigned automatically',
    'pcb.category.escalation': 'Escalation:',
    'pcb.category.sla': 'SLA:',
    'pcb.category.aiKeywords': 'AI Keywords:',
    'pcb.category.customKeywords': 'Custom Keywords:',
    'pcb.category.moreCount': '+{count} more',
    'pcb.category.disabled': 'Disabled',
    'pcb.category.disable': 'Disable',
    'pcb.category.enable': 'Enable',
    'pcb.category.customize': 'Customize',
    'pcb.category.deleteCustomTitle': 'Delete custom category',
    'pcb.category.customizeCategory': 'Customize Category',
    'pcb.category.editDialogDesc': 'Customize priority, escalation level, SLA, and add custom AI keywords for your business',
    'pcb.category.note': 'Note',
    'pcb.category.editNote': 'Customizations only apply to your business. Original category settings are preserved.',
    'pcb.category.customPriority': 'Custom Priority',
    'pcb.category.defaultLabel': 'Default',
    'pcb.category.useDefault': 'Use Default',
    'pcb.category.low': 'Low',
    'pcb.category.medium': 'Medium',
    'pcb.category.high': 'High',
    'pcb.category.critical': 'Critical',
    'pcb.category.leaveEmptyDefault': 'Leave empty to use default',
    'pcb.category.customEscalation': 'Custom Escalation Level',
    'pcb.category.setEscalation': 'Set escalation level',
    'pcb.category.customSlaHours': 'Custom SLA (hours)',
    'pcb.category.egSla24': 'e.g., 24',
    'pcb.category.slaHint': 'Response time target for this category',
    'pcb.category.additionalKeywords': 'Additional AI Keywords (comma-separated)',
    'pcb.category.keywordsPlaceholder': 'e.g., custom phrase, business-specific term, industry jargon',
    'pcb.category.keywordsHint': 'Add business-specific keywords to help AI classify feedback better. These are added to the default keywords.',
    'pcb.category.defaultAiKeywords': 'Default AI Keywords:',
    'pcb.category.saveCustomization': 'Save Customization',
    'pcb.category.createTitle': 'Create Custom Feedback Category',
    'pcb.category.createDesc': 'Add a unique feedback category specific to your business',
    'pcb.category.categoryName': 'Category Name',
    'pcb.category.namePlaceholder': 'e.g., VIP Guest Handling',
    'pcb.category.description': 'Description',
    'pcb.category.descPlaceholder': 'What type of feedback does this category cover?',
    'pcb.category.priorityLevel': 'Priority Level',
    'pcb.category.escalateTo': 'Escalate To',
    'pcb.category.slaHours': 'SLA (hours)',
    'pcb.category.aiKeywordsCsv': 'AI Keywords (comma-separated)',
    'pcb.category.keywordsPlaceholder2': 'e.g., vip, premium guest, special request, concierge',
    'pcb.category.keywordsHint2': 'Keywords help AI automatically classify feedback into this category',
    'pcb.category.createCategory': 'Create Category',
    'pcb.category.customCreated': 'Custom category "{name}" created successfully for your business',
    'pcb.category.customRemoved': 'Custom category "{name}" removed',
    'pcb.category.confirmDelete': 'Delete custom category "{name}"? This cannot be undone.',
    'pcb.category.cannotDelete': 'Cannot delete',
    'pcb.category.inheritedCannotDelete': 'Inherited/universal categories can only be disabled, not deleted.',
    'pcb.category.cannotDeleteInherited': 'Inherited/universal categories cannot be deleted; disable instead.',
    'pcb.category.notFound': 'Category not found (already removed).',
    'pcb.category.deleted': 'Deleted',
    'pcb.category.categoryEnabled': 'Category enabled',
    'pcb.category.categoryDisabled': 'Category disabled',
    'pcb.category.failedSaveCustomization': 'Failed to save customization',
    'pcb.category.failedCreateCustom': 'Failed to create custom category',
    'pcb.category.failedUpdate': 'Failed to update category',
    'pcb.category.failedDelete': 'Failed to delete category',

    // ---- Director Dashboard ----
    'pcb.director.noTicketActivity': 'No ticket activity in the selected period.',
    'pcb.director.ticketStatusDist': 'Ticket Status Distribution',
    'pcb.director.noTicketData': 'No ticket data in the selected period.',
    'pcb.director.conversationIntents': 'Conversation Intents',
    'pcb.director.noIntentData': 'No conversation intent data available yet.',
    'pcb.director.customerSatisfaction': 'Customer Satisfaction',
    'pcb.director.responses': 'responses',
    'pcb.director.aiAutoResolution': 'AI Auto-Resolution',
    'pcb.director.resolvedWithoutStaff': 'Resolved without staff',
    'pcb.director.escalationRate': 'Escalation Rate',
    'pcb.director.callbackRate': 'Callback rate',
    'pcb.director.kpisTitle': 'Key Performance Indicators',
    'pcb.director.avgResolutionTime': 'Average Resolution Time',
    'pcb.director.avgFirstResponseFull': 'Average First Response',
    'pcb.director.reopenedTickets': 'Reopened Tickets',
    'pcb.director.reopenedConversations': 'Reopened Conversations',
    'pcb.director.openaiUsageRate': 'OpenAI Usage Rate',
    'pcb.director.ofTickets': '{resolved} of {total} tickets',
    'pcb.director.periodDay': 'Today',
    'pcb.director.periodWeek': 'This Week',
    'pcb.director.periodMonth': 'This Month',
    'pcb.director.periodQuarter': 'This Quarter',
    'pcb.director.periodYear': 'This Year',

    // ---- Executive Dashboard ----
    'pcb.exec.yourBusiness': 'Your Business',
    'pcb.exec.ticketsRequiringHuman': 'Tickets requiring human',
    'pcb.exec.tabOperations': 'Operations',
    'pcb.exec.tabAiPerformance': 'AI Performance',
    'pcb.exec.tabVoiceChannel': 'Voice Channel',
    'pcb.exec.tabServiceQuality': 'Service Quality',
    'pcb.exec.activeTickets': 'Active Tickets',
    'pcb.exec.openTickets': 'Open Tickets',
    'pcb.exec.openRightNow': 'Open right now',
    'pcb.exec.totalTickets': 'Total Tickets',
    'pcb.exec.resolved': 'resolved',
    'pcb.exec.avgResolution': 'Avg Resolution',
    'pcb.exec.createClose': 'Create → close',
    'pcb.exec.avgFirstResponse': 'Avg First Response',
    'pcb.exec.firstReply': 'First reply',
    'pcb.exec.avgChatDuration': 'Avg Chat Duration',
    'pcb.exec.perResolvedConv': 'Per resolved conversation',
    'pcb.exec.callbackRate': 'Callback Rate',
    'pcb.exec.escalationsPendingCallback': 'Escalations pending callback',
    'pcb.exec.reopenedConversations': 'Reopened Conversations',
    'pcb.exec.requiredFollowup': 'Required follow-up after resolution',
    'pcb.exec.operatorEscalationDist': 'Operator Escalation Distribution',
    'pcb.exec.assigned': 'assigned',
    'pcb.exec.aiConversations': 'AI Conversations',
    'pcb.exec.autoResolution': 'Auto-Resolution',
    'pcb.exec.avgAiConfidence': 'Avg AI Confidence',
    'pcb.exec.openaiFallbackRate': 'OpenAI Fallback Rate',
    'pcb.exec.financialMetricsNote': 'Financial metrics (Revenue, ROI, CLV, Market Share) require billing integration. Contact your administrator to configure billing data sources.',
    'pcb.exec.csatScore': 'CSAT Score',
    'pcb.exec.avgCustomerRating': 'Average customer rating (1–5 scale)',
    'pcb.exec.basedOnRatings': 'Based on {count} customer ratings',
    'pcb.exec.noRatingsCollected': 'No ratings collected yet — customers rate after resolution',
    'pcb.exec.resolutionHealth': 'Resolution Health',
    'pcb.exec.aiResolvedNoHuman': 'AI-resolved without human intervention',
    'pcb.exec.ticketsResolvedOf': '{resolved} of {total} tickets resolved',
    'pcb.exec.noData': 'No data',
    'pcb.exec.callbackSla': 'Callback SLA',
    'pcb.exec.slaBreaches': 'SLA breaches (overdue callbacks)',
    'pcb.exec.pendingOverdue': '{pending} pending, {overdue} overdue',
    'pcb.exec.noVoiceData': 'No voice data',
    'pcb.exec.surveyMetricsNote': 'NPS, employee satisfaction, and market metrics require additional survey and market data integrations. These are not available from operational data alone.',
    'pcb.exec.responses': 'responses',

    // ---- IT Dashboard ----
    'pcb.it.recentEscalations': 'Recent Escalations',
    'pcb.it.noRecentEscalations': 'No recent escalations.',
    'pcb.it.manageIntegrations': 'Manage Integrations in Settings',
    'pcb.it.escalation': 'Escalation',
    'pcb.it.justNow': 'just now',
    'pcb.it.minAgo': '{n}m ago',
    'pcb.it.hourAgo': '{n}h ago',
    'pcb.it.dayAgo': '{n}d ago',
  },

  es: {
    'pcb.common.success': 'Éxito',
    'pcb.common.cancel': 'Cancelar',

    'pcb.category.notSet': 'Sin definir',
    'pcb.category.loadingCategories': 'Cargando categorías de comentarios...',
    'pcb.category.industry': 'Sector',
    'pcb.category.subSector': 'Subsector',
    'pcb.category.addCustom': 'Añadir categoría personalizada',
    'pcb.category.viewAnalytics': 'Ver análisis',
    'pcb.category.totalCategories': 'Total de categorías',
    'pcb.category.enabled': 'Habilitada',
    'pcb.category.customized': 'Personalizada',
    'pcb.category.inherited': 'Heredada',
    'pcb.category.universal': 'Universal',
    'pcb.category.custom': 'Personalizada',
    'pcb.category.activeCategories': 'Categorías de comentarios activas',
    'pcb.category.activeCategoriesDesc': 'Categorías heredadas de tu subsector. Personaliza prioridades, reglas de escalado y palabras clave de IA.',
    'pcb.category.noCategories': 'No se encontraron categorías',
    'pcb.category.noCategoriesHint': 'Completa el perfil de tu negocio para que se asignen categorías de comentarios automáticamente',
    'pcb.category.escalation': 'Escalado:',
    'pcb.category.sla': 'SLA:',
    'pcb.category.aiKeywords': 'Palabras clave de IA:',
    'pcb.category.customKeywords': 'Palabras clave personalizadas:',
    'pcb.category.moreCount': '+{count} más',
    'pcb.category.disabled': 'Deshabilitada',
    'pcb.category.disable': 'Deshabilitar',
    'pcb.category.enable': 'Habilitar',
    'pcb.category.customize': 'Personalizar',
    'pcb.category.deleteCustomTitle': 'Eliminar categoría personalizada',
    'pcb.category.customizeCategory': 'Personalizar categoría',
    'pcb.category.editDialogDesc': 'Personaliza la prioridad, el nivel de escalado, el SLA y añade palabras clave de IA para tu negocio',
    'pcb.category.note': 'Nota',
    'pcb.category.editNote': 'Las personalizaciones solo se aplican a tu negocio. La configuración original de la categoría se conserva.',
    'pcb.category.customPriority': 'Prioridad personalizada',
    'pcb.category.defaultLabel': 'Predeterminado',
    'pcb.category.useDefault': 'Usar predeterminado',
    'pcb.category.low': 'Baja',
    'pcb.category.medium': 'Media',
    'pcb.category.high': 'Alta',
    'pcb.category.critical': 'Crítica',
    'pcb.category.leaveEmptyDefault': 'Deja vacío para usar el predeterminado',
    'pcb.category.customEscalation': 'Nivel de escalado personalizado',
    'pcb.category.setEscalation': 'Establecer nivel de escalado',
    'pcb.category.customSlaHours': 'SLA personalizado (horas)',
    'pcb.category.egSla24': 'p. ej., 24',
    'pcb.category.slaHint': 'Objetivo de tiempo de respuesta para esta categoría',
    'pcb.category.additionalKeywords': 'Palabras clave de IA adicionales (separadas por comas)',
    'pcb.category.keywordsPlaceholder': 'p. ej., frase personalizada, término específico del negocio, jerga del sector',
    'pcb.category.keywordsHint': 'Añade palabras clave específicas del negocio para ayudar a la IA a clasificar mejor los comentarios. Se añaden a las palabras clave predeterminadas.',
    'pcb.category.defaultAiKeywords': 'Palabras clave de IA predeterminadas:',
    'pcb.category.saveCustomization': 'Guardar personalización',
    'pcb.category.createTitle': 'Crear categoría de comentarios personalizada',
    'pcb.category.createDesc': 'Añade una categoría de comentarios única y específica para tu negocio',
    'pcb.category.categoryName': 'Nombre de la categoría',
    'pcb.category.namePlaceholder': 'p. ej., Atención a huéspedes VIP',
    'pcb.category.description': 'Descripción',
    'pcb.category.descPlaceholder': '¿Qué tipo de comentarios cubre esta categoría?',
    'pcb.category.priorityLevel': 'Nivel de prioridad',
    'pcb.category.escalateTo': 'Escalar a',
    'pcb.category.slaHours': 'SLA (horas)',
    'pcb.category.aiKeywordsCsv': 'Palabras clave de IA (separadas por comas)',
    'pcb.category.keywordsPlaceholder2': 'p. ej., vip, huésped premium, solicitud especial, conserje',
    'pcb.category.keywordsHint2': 'Las palabras clave ayudan a la IA a clasificar automáticamente los comentarios en esta categoría',
    'pcb.category.createCategory': 'Crear categoría',
    'pcb.category.customCreated': 'Categoría personalizada "{name}" creada correctamente para tu negocio',
    'pcb.category.customRemoved': 'Categoría personalizada "{name}" eliminada',
    'pcb.category.confirmDelete': '¿Eliminar la categoría personalizada "{name}"? Esta acción no se puede deshacer.',
    'pcb.category.cannotDelete': 'No se puede eliminar',
    'pcb.category.inheritedCannotDelete': 'Las categorías heredadas/universales solo se pueden deshabilitar, no eliminar.',
    'pcb.category.cannotDeleteInherited': 'Las categorías heredadas/universales no se pueden eliminar; deshabilítalas en su lugar.',
    'pcb.category.notFound': 'Categoría no encontrada (ya eliminada).',
    'pcb.category.deleted': 'Eliminada',
    'pcb.category.categoryEnabled': 'Categoría habilitada',
    'pcb.category.categoryDisabled': 'Categoría deshabilitada',
    'pcb.category.failedSaveCustomization': 'No se pudo guardar la personalización',
    'pcb.category.failedCreateCustom': 'No se pudo crear la categoría personalizada',
    'pcb.category.failedUpdate': 'No se pudo actualizar la categoría',
    'pcb.category.failedDelete': 'No se pudo eliminar la categoría',

    'pcb.director.noTicketActivity': 'No hay actividad de tickets en el período seleccionado.',
    'pcb.director.ticketStatusDist': 'Distribución del estado de los tickets',
    'pcb.director.noTicketData': 'No hay datos de tickets en el período seleccionado.',
    'pcb.director.conversationIntents': 'Intenciones de conversación',
    'pcb.director.noIntentData': 'Aún no hay datos de intención de conversación disponibles.',
    'pcb.director.customerSatisfaction': 'Satisfacción del cliente',
    'pcb.director.responses': 'respuestas',
    'pcb.director.aiAutoResolution': 'Autorresolución con IA',
    'pcb.director.resolvedWithoutStaff': 'Resueltos sin personal',
    'pcb.director.escalationRate': 'Tasa de escalado',
    'pcb.director.callbackRate': 'Tasa de devolución de llamadas',
    'pcb.director.kpisTitle': 'Indicadores clave de rendimiento',
    'pcb.director.avgResolutionTime': 'Tiempo medio de resolución',
    'pcb.director.avgFirstResponseFull': 'Primera respuesta media',
    'pcb.director.reopenedTickets': 'Tickets reabiertos',
    'pcb.director.reopenedConversations': 'Conversaciones reabiertas',
    'pcb.director.openaiUsageRate': 'Tasa de uso de OpenAI',
    'pcb.director.ofTickets': '{resolved} de {total} tickets',
    'pcb.director.periodDay': 'Hoy',
    'pcb.director.periodWeek': 'Esta semana',
    'pcb.director.periodMonth': 'Este mes',
    'pcb.director.periodQuarter': 'Este trimestre',
    'pcb.director.periodYear': 'Este año',

    'pcb.exec.yourBusiness': 'Tu negocio',
    'pcb.exec.ticketsRequiringHuman': 'Tickets que requieren intervención humana',
    'pcb.exec.tabOperations': 'Operaciones',
    'pcb.exec.tabAiPerformance': 'Rendimiento de la IA',
    'pcb.exec.tabVoiceChannel': 'Canal de voz',
    'pcb.exec.tabServiceQuality': 'Calidad del servicio',
    'pcb.exec.activeTickets': 'Tickets activos',
    'pcb.exec.openRightNow': 'Abiertos ahora mismo',
    'pcb.exec.totalTickets': 'Total de tickets',
    'pcb.exec.resolved': 'resueltos',
    'pcb.exec.avgResolution': 'Resolución media',
    'pcb.exec.createClose': 'Creación → cierre',
    'pcb.exec.avgFirstResponse': 'Primera respuesta media',
    'pcb.exec.firstReply': 'Primera respuesta',
    'pcb.exec.avgChatDuration': 'Duración media del chat',
    'pcb.exec.perResolvedConv': 'Por conversación resuelta',
    'pcb.exec.callbackRate': 'Tasa de devolución de llamadas',
    'pcb.exec.escalationsPendingCallback': 'Escalados pendientes de devolución de llamada',
    'pcb.exec.reopenedConversations': 'Conversaciones reabiertas',
    'pcb.exec.requiredFollowup': 'Seguimiento requerido tras la resolución',
    'pcb.exec.operatorEscalationDist': 'Distribución de escalados por operador',
    'pcb.exec.assigned': 'asignados',
    'pcb.exec.aiConversations': 'Conversaciones con IA',
    'pcb.exec.autoResolution': 'Autorresolución',
    'pcb.exec.avgAiConfidence': 'Confianza media de la IA',
    'pcb.exec.openaiFallbackRate': 'Tasa de recurso a OpenAI',
    'pcb.exec.financialMetricsNote': 'Las métricas financieras (ingresos, ROI, CLV, cuota de mercado) requieren integración de facturación. Contacta con tu administrador para configurar las fuentes de datos de facturación.',
    'pcb.exec.csatScore': 'Puntuación CSAT',
    'pcb.exec.avgCustomerRating': 'Valoración media del cliente (escala 1–5)',
    'pcb.exec.basedOnRatings': 'Basado en {count} valoraciones de clientes',
    'pcb.exec.noRatingsCollected': 'Aún no se han recopilado valoraciones: los clientes valoran tras la resolución',
    'pcb.exec.resolutionHealth': 'Salud de resolución',
    'pcb.exec.aiResolvedNoHuman': 'Resuelto por IA sin intervención humana',
    'pcb.exec.ticketsResolvedOf': '{resolved} de {total} tickets resueltos',
    'pcb.exec.noData': 'Sin datos',
    'pcb.exec.callbackSla': 'SLA de devolución de llamadas',
    'pcb.exec.slaBreaches': 'Incumplimientos de SLA (devoluciones vencidas)',
    'pcb.exec.pendingOverdue': '{pending} pendientes, {overdue} vencidas',
    'pcb.exec.noVoiceData': 'Sin datos de voz',
    'pcb.exec.surveyMetricsNote': 'El NPS, la satisfacción de los empleados y las métricas de mercado requieren integraciones adicionales de datos de encuestas y de mercado. No están disponibles solo con datos operativos.',
    'pcb.exec.responses': 'respuestas',

    'pcb.it.recentEscalations': 'Escalados recientes',
    'pcb.it.noRecentEscalations': 'No hay escalados recientes.',
    'pcb.it.manageIntegrations': 'Gestionar integraciones en Ajustes',
    'pcb.it.escalation': 'Escalado',
    'pcb.it.justNow': 'ahora mismo',
    'pcb.it.minAgo': 'hace {n} min',
    'pcb.it.hourAgo': 'hace {n} h',
    'pcb.it.dayAgo': 'hace {n} d',
  },

  fr: {
    'pcb.common.success': 'Succès',
    'pcb.common.cancel': 'Annuler',

    'pcb.category.notSet': 'Non défini',
    'pcb.category.loadingCategories': 'Chargement des catégories de retours...',
    'pcb.category.industry': 'Secteur',
    'pcb.category.subSector': 'Sous-secteur',
    'pcb.category.addCustom': 'Ajouter une catégorie personnalisée',
    'pcb.category.viewAnalytics': 'Voir les analyses',
    'pcb.category.totalCategories': 'Total des catégories',
    'pcb.category.enabled': 'Activée',
    'pcb.category.customized': 'Personnalisée',
    'pcb.category.inherited': 'Héritée',
    'pcb.category.universal': 'Universelle',
    'pcb.category.custom': 'Personnalisée',
    'pcb.category.activeCategories': 'Catégories de retours actives',
    'pcb.category.activeCategoriesDesc': 'Catégories héritées de votre sous-secteur. Personnalisez les priorités, les règles d\'escalade et les mots-clés IA.',
    'pcb.category.noCategories': 'Aucune catégorie trouvée',
    'pcb.category.noCategoriesHint': 'Complétez le profil de votre entreprise pour que les catégories de retours soient attribuées automatiquement',
    'pcb.category.escalation': 'Escalade :',
    'pcb.category.sla': 'SLA :',
    'pcb.category.aiKeywords': 'Mots-clés IA :',
    'pcb.category.customKeywords': 'Mots-clés personnalisés :',
    'pcb.category.moreCount': '+{count} de plus',
    'pcb.category.disabled': 'Désactivée',
    'pcb.category.disable': 'Désactiver',
    'pcb.category.enable': 'Activer',
    'pcb.category.customize': 'Personnaliser',
    'pcb.category.deleteCustomTitle': 'Supprimer la catégorie personnalisée',
    'pcb.category.customizeCategory': 'Personnaliser la catégorie',
    'pcb.category.editDialogDesc': 'Personnalisez la priorité, le niveau d\'escalade, le SLA et ajoutez des mots-clés IA pour votre entreprise',
    'pcb.category.note': 'Remarque',
    'pcb.category.editNote': 'Les personnalisations ne s\'appliquent qu\'à votre entreprise. Les paramètres d\'origine de la catégorie sont conservés.',
    'pcb.category.customPriority': 'Priorité personnalisée',
    'pcb.category.defaultLabel': 'Par défaut',
    'pcb.category.useDefault': 'Utiliser la valeur par défaut',
    'pcb.category.low': 'Faible',
    'pcb.category.medium': 'Moyenne',
    'pcb.category.high': 'Élevée',
    'pcb.category.critical': 'Critique',
    'pcb.category.leaveEmptyDefault': 'Laissez vide pour utiliser la valeur par défaut',
    'pcb.category.customEscalation': 'Niveau d\'escalade personnalisé',
    'pcb.category.setEscalation': 'Définir le niveau d\'escalade',
    'pcb.category.customSlaHours': 'SLA personnalisé (heures)',
    'pcb.category.egSla24': 'p. ex., 24',
    'pcb.category.slaHint': 'Objectif de temps de réponse pour cette catégorie',
    'pcb.category.additionalKeywords': 'Mots-clés IA supplémentaires (séparés par des virgules)',
    'pcb.category.keywordsPlaceholder': 'p. ex., phrase personnalisée, terme spécifique à l\'entreprise, jargon du secteur',
    'pcb.category.keywordsHint': 'Ajoutez des mots-clés spécifiques à l\'entreprise pour aider l\'IA à mieux classer les retours. Ils s\'ajoutent aux mots-clés par défaut.',
    'pcb.category.defaultAiKeywords': 'Mots-clés IA par défaut :',
    'pcb.category.saveCustomization': 'Enregistrer la personnalisation',
    'pcb.category.createTitle': 'Créer une catégorie de retours personnalisée',
    'pcb.category.createDesc': 'Ajoutez une catégorie de retours unique et spécifique à votre entreprise',
    'pcb.category.categoryName': 'Nom de la catégorie',
    'pcb.category.namePlaceholder': 'p. ex., Gestion des clients VIP',
    'pcb.category.description': 'Description',
    'pcb.category.descPlaceholder': 'Quel type de retours cette catégorie couvre-t-elle ?',
    'pcb.category.priorityLevel': 'Niveau de priorité',
    'pcb.category.escalateTo': 'Escalader vers',
    'pcb.category.slaHours': 'SLA (heures)',
    'pcb.category.aiKeywordsCsv': 'Mots-clés IA (séparés par des virgules)',
    'pcb.category.keywordsPlaceholder2': 'p. ex., vip, client premium, demande spéciale, conciergerie',
    'pcb.category.keywordsHint2': 'Les mots-clés aident l\'IA à classer automatiquement les retours dans cette catégorie',
    'pcb.category.createCategory': 'Créer la catégorie',
    'pcb.category.customCreated': 'Catégorie personnalisée « {name} » créée avec succès pour votre entreprise',
    'pcb.category.customRemoved': 'Catégorie personnalisée « {name} » supprimée',
    'pcb.category.confirmDelete': 'Supprimer la catégorie personnalisée « {name} » ? Cette action est irréversible.',
    'pcb.category.cannotDelete': 'Suppression impossible',
    'pcb.category.inheritedCannotDelete': 'Les catégories héritées/universelles peuvent seulement être désactivées, pas supprimées.',
    'pcb.category.cannotDeleteInherited': 'Les catégories héritées/universelles ne peuvent pas être supprimées ; désactivez-les à la place.',
    'pcb.category.notFound': 'Catégorie introuvable (déjà supprimée).',
    'pcb.category.deleted': 'Supprimée',
    'pcb.category.categoryEnabled': 'Catégorie activée',
    'pcb.category.categoryDisabled': 'Catégorie désactivée',
    'pcb.category.failedSaveCustomization': 'Échec de l\'enregistrement de la personnalisation',
    'pcb.category.failedCreateCustom': 'Échec de la création de la catégorie personnalisée',
    'pcb.category.failedUpdate': 'Échec de la mise à jour de la catégorie',
    'pcb.category.failedDelete': 'Échec de la suppression de la catégorie',

    'pcb.director.noTicketActivity': 'Aucune activité de ticket sur la période sélectionnée.',
    'pcb.director.ticketStatusDist': 'Répartition du statut des tickets',
    'pcb.director.noTicketData': 'Aucune donnée de ticket sur la période sélectionnée.',
    'pcb.director.conversationIntents': 'Intentions de conversation',
    'pcb.director.noIntentData': 'Aucune donnée d\'intention de conversation disponible pour l\'instant.',
    'pcb.director.customerSatisfaction': 'Satisfaction client',
    'pcb.director.responses': 'réponses',
    'pcb.director.aiAutoResolution': 'Résolution automatique par IA',
    'pcb.director.resolvedWithoutStaff': 'Résolus sans personnel',
    'pcb.director.escalationRate': 'Taux d\'escalade',
    'pcb.director.callbackRate': 'Taux de rappel',
    'pcb.director.kpisTitle': 'Indicateurs clés de performance',
    'pcb.director.avgResolutionTime': 'Temps de résolution moyen',
    'pcb.director.avgFirstResponseFull': 'Première réponse moyenne',
    'pcb.director.reopenedTickets': 'Tickets rouverts',
    'pcb.director.reopenedConversations': 'Conversations rouvertes',
    'pcb.director.openaiUsageRate': 'Taux d\'utilisation d\'OpenAI',
    'pcb.director.ofTickets': '{resolved} sur {total} tickets',
    'pcb.director.periodDay': 'Aujourd\'hui',
    'pcb.director.periodWeek': 'Cette semaine',
    'pcb.director.periodMonth': 'Ce mois-ci',
    'pcb.director.periodQuarter': 'Ce trimestre',
    'pcb.director.periodYear': 'Cette année',

    'pcb.exec.yourBusiness': 'Votre entreprise',
    'pcb.exec.ticketsRequiringHuman': 'Tickets nécessitant une intervention humaine',
    'pcb.exec.tabOperations': 'Opérations',
    'pcb.exec.tabAiPerformance': 'Performance de l\'IA',
    'pcb.exec.tabVoiceChannel': 'Canal vocal',
    'pcb.exec.tabServiceQuality': 'Qualité de service',
    'pcb.exec.activeTickets': 'Tickets actifs',
    'pcb.exec.openRightNow': 'Ouverts en ce moment',
    'pcb.exec.totalTickets': 'Total des tickets',
    'pcb.exec.resolved': 'résolus',
    'pcb.exec.avgResolution': 'Résolution moyenne',
    'pcb.exec.createClose': 'Création → clôture',
    'pcb.exec.avgFirstResponse': 'Première réponse moyenne',
    'pcb.exec.firstReply': 'Première réponse',
    'pcb.exec.avgChatDuration': 'Durée moyenne du chat',
    'pcb.exec.perResolvedConv': 'Par conversation résolue',
    'pcb.exec.callbackRate': 'Taux de rappel',
    'pcb.exec.escalationsPendingCallback': 'Escalades en attente de rappel',
    'pcb.exec.reopenedConversations': 'Conversations rouvertes',
    'pcb.exec.requiredFollowup': 'Suivi requis après résolution',
    'pcb.exec.operatorEscalationDist': 'Répartition des escalades par opérateur',
    'pcb.exec.assigned': 'attribués',
    'pcb.exec.aiConversations': 'Conversations IA',
    'pcb.exec.autoResolution': 'Résolution automatique',
    'pcb.exec.avgAiConfidence': 'Confiance moyenne de l\'IA',
    'pcb.exec.openaiFallbackRate': 'Taux de recours à OpenAI',
    'pcb.exec.financialMetricsNote': 'Les métriques financières (chiffre d\'affaires, ROI, CLV, part de marché) nécessitent une intégration de facturation. Contactez votre administrateur pour configurer les sources de données de facturation.',
    'pcb.exec.csatScore': 'Score CSAT',
    'pcb.exec.avgCustomerRating': 'Note moyenne des clients (échelle 1–5)',
    'pcb.exec.basedOnRatings': 'Basé sur {count} évaluations de clients',
    'pcb.exec.noRatingsCollected': 'Aucune évaluation collectée pour l\'instant — les clients notent après résolution',
    'pcb.exec.resolutionHealth': 'Santé de résolution',
    'pcb.exec.aiResolvedNoHuman': 'Résolu par IA sans intervention humaine',
    'pcb.exec.ticketsResolvedOf': '{resolved} sur {total} tickets résolus',
    'pcb.exec.noData': 'Aucune donnée',
    'pcb.exec.callbackSla': 'SLA de rappel',
    'pcb.exec.slaBreaches': 'Non-respects du SLA (rappels en retard)',
    'pcb.exec.pendingOverdue': '{pending} en attente, {overdue} en retard',
    'pcb.exec.noVoiceData': 'Aucune donnée vocale',
    'pcb.exec.surveyMetricsNote': 'Le NPS, la satisfaction des employés et les métriques de marché nécessitent des intégrations supplémentaires de données d\'enquête et de marché. Elles ne sont pas disponibles à partir des seules données opérationnelles.',
    'pcb.exec.responses': 'réponses',

    'pcb.it.recentEscalations': 'Escalades récentes',
    'pcb.it.noRecentEscalations': 'Aucune escalade récente.',
    'pcb.it.manageIntegrations': 'Gérer les intégrations dans les paramètres',
    'pcb.it.escalation': 'Escalade',
    'pcb.it.justNow': 'à l\'instant',
    'pcb.it.minAgo': 'il y a {n} min',
    'pcb.it.hourAgo': 'il y a {n} h',
    'pcb.it.dayAgo': 'il y a {n} j',
  },

  pt: {
    'pcb.common.success': 'Sucesso',
    'pcb.common.cancel': 'Cancelar',

    'pcb.category.notSet': 'Não definido',
    'pcb.category.loadingCategories': 'A carregar categorias de feedback...',
    'pcb.category.industry': 'Setor',
    'pcb.category.subSector': 'Subsetor',
    'pcb.category.addCustom': 'Adicionar categoria personalizada',
    'pcb.category.viewAnalytics': 'Ver análises',
    'pcb.category.totalCategories': 'Total de categorias',
    'pcb.category.enabled': 'Ativada',
    'pcb.category.customized': 'Personalizada',
    'pcb.category.inherited': 'Herdada',
    'pcb.category.universal': 'Universal',
    'pcb.category.custom': 'Personalizada',
    'pcb.category.activeCategories': 'Categorias de feedback ativas',
    'pcb.category.activeCategoriesDesc': 'Categorias herdadas do seu subsetor. Personalize prioridades, regras de escalonamento e palavras-chave de IA.',
    'pcb.category.noCategories': 'Nenhuma categoria encontrada',
    'pcb.category.noCategoriesHint': 'Complete o perfil da sua empresa para que as categorias de feedback sejam atribuídas automaticamente',
    'pcb.category.escalation': 'Escalonamento:',
    'pcb.category.sla': 'SLA:',
    'pcb.category.aiKeywords': 'Palavras-chave de IA:',
    'pcb.category.customKeywords': 'Palavras-chave personalizadas:',
    'pcb.category.moreCount': '+{count} mais',
    'pcb.category.disabled': 'Desativada',
    'pcb.category.disable': 'Desativar',
    'pcb.category.enable': 'Ativar',
    'pcb.category.customize': 'Personalizar',
    'pcb.category.deleteCustomTitle': 'Eliminar categoria personalizada',
    'pcb.category.customizeCategory': 'Personalizar categoria',
    'pcb.category.editDialogDesc': 'Personalize a prioridade, o nível de escalonamento, o SLA e adicione palavras-chave de IA para a sua empresa',
    'pcb.category.note': 'Nota',
    'pcb.category.editNote': 'As personalizações só se aplicam à sua empresa. As definições originais da categoria são preservadas.',
    'pcb.category.customPriority': 'Prioridade personalizada',
    'pcb.category.defaultLabel': 'Predefinição',
    'pcb.category.useDefault': 'Usar predefinição',
    'pcb.category.low': 'Baixa',
    'pcb.category.medium': 'Média',
    'pcb.category.high': 'Alta',
    'pcb.category.critical': 'Crítica',
    'pcb.category.leaveEmptyDefault': 'Deixe em branco para usar a predefinição',
    'pcb.category.customEscalation': 'Nível de escalonamento personalizado',
    'pcb.category.setEscalation': 'Definir nível de escalonamento',
    'pcb.category.customSlaHours': 'SLA personalizado (horas)',
    'pcb.category.egSla24': 'p. ex., 24',
    'pcb.category.slaHint': 'Objetivo de tempo de resposta para esta categoria',
    'pcb.category.additionalKeywords': 'Palavras-chave de IA adicionais (separadas por vírgulas)',
    'pcb.category.keywordsPlaceholder': 'p. ex., frase personalizada, termo específico da empresa, jargão do setor',
    'pcb.category.keywordsHint': 'Adicione palavras-chave específicas da empresa para ajudar a IA a classificar melhor o feedback. São adicionadas às palavras-chave predefinidas.',
    'pcb.category.defaultAiKeywords': 'Palavras-chave de IA predefinidas:',
    'pcb.category.saveCustomization': 'Guardar personalização',
    'pcb.category.createTitle': 'Criar categoria de feedback personalizada',
    'pcb.category.createDesc': 'Adicione uma categoria de feedback única e específica para a sua empresa',
    'pcb.category.categoryName': 'Nome da categoria',
    'pcb.category.namePlaceholder': 'p. ex., Atendimento a hóspedes VIP',
    'pcb.category.description': 'Descrição',
    'pcb.category.descPlaceholder': 'Que tipo de feedback esta categoria abrange?',
    'pcb.category.priorityLevel': 'Nível de prioridade',
    'pcb.category.escalateTo': 'Escalonar para',
    'pcb.category.slaHours': 'SLA (horas)',
    'pcb.category.aiKeywordsCsv': 'Palavras-chave de IA (separadas por vírgulas)',
    'pcb.category.keywordsPlaceholder2': 'p. ex., vip, hóspede premium, pedido especial, concierge',
    'pcb.category.keywordsHint2': 'As palavras-chave ajudam a IA a classificar automaticamente o feedback nesta categoria',
    'pcb.category.createCategory': 'Criar categoria',
    'pcb.category.customCreated': 'Categoria personalizada "{name}" criada com sucesso para a sua empresa',
    'pcb.category.customRemoved': 'Categoria personalizada "{name}" removida',
    'pcb.category.confirmDelete': 'Eliminar a categoria personalizada "{name}"? Esta ação não pode ser anulada.',
    'pcb.category.cannotDelete': 'Não é possível eliminar',
    'pcb.category.inheritedCannotDelete': 'As categorias herdadas/universais só podem ser desativadas, não eliminadas.',
    'pcb.category.cannotDeleteInherited': 'As categorias herdadas/universais não podem ser eliminadas; desative-as em vez disso.',
    'pcb.category.notFound': 'Categoria não encontrada (já removida).',
    'pcb.category.deleted': 'Eliminada',
    'pcb.category.categoryEnabled': 'Categoria ativada',
    'pcb.category.categoryDisabled': 'Categoria desativada',
    'pcb.category.failedSaveCustomization': 'Falha ao guardar a personalização',
    'pcb.category.failedCreateCustom': 'Falha ao criar a categoria personalizada',
    'pcb.category.failedUpdate': 'Falha ao atualizar a categoria',
    'pcb.category.failedDelete': 'Falha ao eliminar a categoria',

    'pcb.director.noTicketActivity': 'Sem atividade de tickets no período selecionado.',
    'pcb.director.ticketStatusDist': 'Distribuição do estado dos tickets',
    'pcb.director.noTicketData': 'Sem dados de tickets no período selecionado.',
    'pcb.director.conversationIntents': 'Intenções de conversa',
    'pcb.director.noIntentData': 'Ainda não há dados de intenção de conversa disponíveis.',
    'pcb.director.customerSatisfaction': 'Satisfação do cliente',
    'pcb.director.responses': 'respostas',
    'pcb.director.aiAutoResolution': 'Autorresolução por IA',
    'pcb.director.resolvedWithoutStaff': 'Resolvidos sem pessoal',
    'pcb.director.escalationRate': 'Taxa de escalonamento',
    'pcb.director.callbackRate': 'Taxa de retorno de chamada',
    'pcb.director.kpisTitle': 'Indicadores-chave de desempenho',
    'pcb.director.avgResolutionTime': 'Tempo médio de resolução',
    'pcb.director.avgFirstResponseFull': 'Primeira resposta média',
    'pcb.director.reopenedTickets': 'Tickets reabertos',
    'pcb.director.reopenedConversations': 'Conversas reabertas',
    'pcb.director.openaiUsageRate': 'Taxa de utilização do OpenAI',
    'pcb.director.ofTickets': '{resolved} de {total} tickets',
    'pcb.director.periodDay': 'Hoje',
    'pcb.director.periodWeek': 'Esta semana',
    'pcb.director.periodMonth': 'Este mês',
    'pcb.director.periodQuarter': 'Este trimestre',
    'pcb.director.periodYear': 'Este ano',

    'pcb.exec.yourBusiness': 'A sua empresa',
    'pcb.exec.ticketsRequiringHuman': 'Tickets que exigem intervenção humana',
    'pcb.exec.tabOperations': 'Operações',
    'pcb.exec.tabAiPerformance': 'Desempenho da IA',
    'pcb.exec.tabVoiceChannel': 'Canal de voz',
    'pcb.exec.tabServiceQuality': 'Qualidade do serviço',
    'pcb.exec.activeTickets': 'Tickets ativos',
    'pcb.exec.openRightNow': 'Abertos agora mesmo',
    'pcb.exec.totalTickets': 'Total de tickets',
    'pcb.exec.resolved': 'resolvidos',
    'pcb.exec.avgResolution': 'Resolução média',
    'pcb.exec.createClose': 'Criação → fecho',
    'pcb.exec.avgFirstResponse': 'Primeira resposta média',
    'pcb.exec.firstReply': 'Primeira resposta',
    'pcb.exec.avgChatDuration': 'Duração média do chat',
    'pcb.exec.perResolvedConv': 'Por conversa resolvida',
    'pcb.exec.callbackRate': 'Taxa de retorno de chamada',
    'pcb.exec.escalationsPendingCallback': 'Escalonamentos pendentes de retorno de chamada',
    'pcb.exec.reopenedConversations': 'Conversas reabertas',
    'pcb.exec.requiredFollowup': 'Acompanhamento necessário após a resolução',
    'pcb.exec.operatorEscalationDist': 'Distribuição de escalonamentos por operador',
    'pcb.exec.assigned': 'atribuídos',
    'pcb.exec.aiConversations': 'Conversas com IA',
    'pcb.exec.autoResolution': 'Autorresolução',
    'pcb.exec.avgAiConfidence': 'Confiança média da IA',
    'pcb.exec.openaiFallbackRate': 'Taxa de recurso ao OpenAI',
    'pcb.exec.financialMetricsNote': 'As métricas financeiras (receita, ROI, CLV, quota de mercado) exigem integração de faturação. Contacte o seu administrador para configurar as fontes de dados de faturação.',
    'pcb.exec.csatScore': 'Pontuação CSAT',
    'pcb.exec.avgCustomerRating': 'Avaliação média do cliente (escala 1–5)',
    'pcb.exec.basedOnRatings': 'Com base em {count} avaliações de clientes',
    'pcb.exec.noRatingsCollected': 'Ainda não foram recolhidas avaliações — os clientes avaliam após a resolução',
    'pcb.exec.resolutionHealth': 'Saúde de resolução',
    'pcb.exec.aiResolvedNoHuman': 'Resolvido por IA sem intervenção humana',
    'pcb.exec.ticketsResolvedOf': '{resolved} de {total} tickets resolvidos',
    'pcb.exec.noData': 'Sem dados',
    'pcb.exec.callbackSla': 'SLA de retorno de chamada',
    'pcb.exec.slaBreaches': 'Incumprimentos de SLA (retornos em atraso)',
    'pcb.exec.pendingOverdue': '{pending} pendentes, {overdue} em atraso',
    'pcb.exec.noVoiceData': 'Sem dados de voz',
    'pcb.exec.surveyMetricsNote': 'O NPS, a satisfação dos colaboradores e as métricas de mercado exigem integrações adicionais de dados de inquéritos e de mercado. Não estão disponíveis apenas a partir de dados operacionais.',
    'pcb.exec.responses': 'respostas',

    'pcb.it.recentEscalations': 'Escalonamentos recentes',
    'pcb.it.noRecentEscalations': 'Sem escalonamentos recentes.',
    'pcb.it.manageIntegrations': 'Gerir integrações nas Definições',
    'pcb.it.escalation': 'Escalonamento',
    'pcb.it.justNow': 'agora mesmo',
    'pcb.it.minAgo': 'há {n} min',
    'pcb.it.hourAgo': 'há {n} h',
    'pcb.it.dayAgo': 'há {n} d',
  },

  de: {
    'pcb.common.success': 'Erfolg',
    'pcb.common.cancel': 'Abbrechen',

    'pcb.category.notSet': 'Nicht festgelegt',
    'pcb.category.loadingCategories': 'Feedback-Kategorien werden geladen...',
    'pcb.category.industry': 'Branche',
    'pcb.category.subSector': 'Teilbranche',
    'pcb.category.addCustom': 'Benutzerdefinierte Kategorie hinzufügen',
    'pcb.category.viewAnalytics': 'Analysen anzeigen',
    'pcb.category.totalCategories': 'Kategorien gesamt',
    'pcb.category.enabled': 'Aktiviert',
    'pcb.category.customized': 'Angepasst',
    'pcb.category.inherited': 'Geerbt',
    'pcb.category.universal': 'Universell',
    'pcb.category.custom': 'Benutzerdefiniert',
    'pcb.category.activeCategories': 'Aktive Feedback-Kategorien',
    'pcb.category.activeCategoriesDesc': 'Von Ihrer Teilbranche geerbte Kategorien. Passen Sie Prioritäten, Eskalationsregeln und KI-Schlüsselwörter an.',
    'pcb.category.noCategories': 'Keine Kategorien gefunden',
    'pcb.category.noCategoriesHint': 'Vervollständigen Sie Ihr Unternehmensprofil, damit Feedback-Kategorien automatisch zugewiesen werden',
    'pcb.category.escalation': 'Eskalation:',
    'pcb.category.sla': 'SLA:',
    'pcb.category.aiKeywords': 'KI-Schlüsselwörter:',
    'pcb.category.customKeywords': 'Benutzerdefinierte Schlüsselwörter:',
    'pcb.category.moreCount': '+{count} weitere',
    'pcb.category.disabled': 'Deaktiviert',
    'pcb.category.disable': 'Deaktivieren',
    'pcb.category.enable': 'Aktivieren',
    'pcb.category.customize': 'Anpassen',
    'pcb.category.deleteCustomTitle': 'Benutzerdefinierte Kategorie löschen',
    'pcb.category.customizeCategory': 'Kategorie anpassen',
    'pcb.category.editDialogDesc': 'Passen Sie Priorität, Eskalationsstufe und SLA an und fügen Sie benutzerdefinierte KI-Schlüsselwörter für Ihr Unternehmen hinzu',
    'pcb.category.note': 'Hinweis',
    'pcb.category.editNote': 'Anpassungen gelten nur für Ihr Unternehmen. Die ursprünglichen Kategorieeinstellungen bleiben erhalten.',
    'pcb.category.customPriority': 'Benutzerdefinierte Priorität',
    'pcb.category.defaultLabel': 'Standard',
    'pcb.category.useDefault': 'Standard verwenden',
    'pcb.category.low': 'Niedrig',
    'pcb.category.medium': 'Mittel',
    'pcb.category.high': 'Hoch',
    'pcb.category.critical': 'Kritisch',
    'pcb.category.leaveEmptyDefault': 'Leer lassen, um den Standard zu verwenden',
    'pcb.category.customEscalation': 'Benutzerdefinierte Eskalationsstufe',
    'pcb.category.setEscalation': 'Eskalationsstufe festlegen',
    'pcb.category.customSlaHours': 'Benutzerdefiniertes SLA (Stunden)',
    'pcb.category.egSla24': 'z. B. 24',
    'pcb.category.slaHint': 'Reaktionszeitziel für diese Kategorie',
    'pcb.category.additionalKeywords': 'Zusätzliche KI-Schlüsselwörter (durch Kommas getrennt)',
    'pcb.category.keywordsPlaceholder': 'z. B. individuelle Formulierung, unternehmensspezifischer Begriff, Branchenjargon',
    'pcb.category.keywordsHint': 'Fügen Sie unternehmensspezifische Schlüsselwörter hinzu, damit die KI Feedback besser klassifiziert. Sie werden zu den Standard-Schlüsselwörtern hinzugefügt.',
    'pcb.category.defaultAiKeywords': 'Standard-KI-Schlüsselwörter:',
    'pcb.category.saveCustomization': 'Anpassung speichern',
    'pcb.category.createTitle': 'Benutzerdefinierte Feedback-Kategorie erstellen',
    'pcb.category.createDesc': 'Fügen Sie eine einzigartige, unternehmensspezifische Feedback-Kategorie hinzu',
    'pcb.category.categoryName': 'Kategoriename',
    'pcb.category.namePlaceholder': 'z. B. VIP-Gästebetreuung',
    'pcb.category.description': 'Beschreibung',
    'pcb.category.descPlaceholder': 'Welche Art von Feedback deckt diese Kategorie ab?',
    'pcb.category.priorityLevel': 'Prioritätsstufe',
    'pcb.category.escalateTo': 'Eskalieren an',
    'pcb.category.slaHours': 'SLA (Stunden)',
    'pcb.category.aiKeywordsCsv': 'KI-Schlüsselwörter (durch Kommas getrennt)',
    'pcb.category.keywordsPlaceholder2': 'z. B. vip, Premium-Gast, Sonderwunsch, Concierge',
    'pcb.category.keywordsHint2': 'Schlüsselwörter helfen der KI, Feedback automatisch dieser Kategorie zuzuordnen',
    'pcb.category.createCategory': 'Kategorie erstellen',
    'pcb.category.customCreated': 'Benutzerdefinierte Kategorie „{name}" erfolgreich für Ihr Unternehmen erstellt',
    'pcb.category.customRemoved': 'Benutzerdefinierte Kategorie „{name}" entfernt',
    'pcb.category.confirmDelete': 'Benutzerdefinierte Kategorie „{name}" löschen? Dies kann nicht rückgängig gemacht werden.',
    'pcb.category.cannotDelete': 'Löschen nicht möglich',
    'pcb.category.inheritedCannotDelete': 'Geerbte/universelle Kategorien können nur deaktiviert, nicht gelöscht werden.',
    'pcb.category.cannotDeleteInherited': 'Geerbte/universelle Kategorien können nicht gelöscht werden; deaktivieren Sie sie stattdessen.',
    'pcb.category.notFound': 'Kategorie nicht gefunden (bereits entfernt).',
    'pcb.category.deleted': 'Gelöscht',
    'pcb.category.categoryEnabled': 'Kategorie aktiviert',
    'pcb.category.categoryDisabled': 'Kategorie deaktiviert',
    'pcb.category.failedSaveCustomization': 'Anpassung konnte nicht gespeichert werden',
    'pcb.category.failedCreateCustom': 'Benutzerdefinierte Kategorie konnte nicht erstellt werden',
    'pcb.category.failedUpdate': 'Kategorie konnte nicht aktualisiert werden',
    'pcb.category.failedDelete': 'Kategorie konnte nicht gelöscht werden',

    'pcb.director.noTicketActivity': 'Keine Ticket-Aktivität im ausgewählten Zeitraum.',
    'pcb.director.ticketStatusDist': 'Verteilung des Ticketstatus',
    'pcb.director.noTicketData': 'Keine Ticketdaten im ausgewählten Zeitraum.',
    'pcb.director.conversationIntents': 'Gesprächsabsichten',
    'pcb.director.noIntentData': 'Noch keine Daten zu Gesprächsabsichten verfügbar.',
    'pcb.director.customerSatisfaction': 'Kundenzufriedenheit',
    'pcb.director.responses': 'Antworten',
    'pcb.director.aiAutoResolution': 'KI-Autolösung',
    'pcb.director.resolvedWithoutStaff': 'Ohne Mitarbeiter gelöst',
    'pcb.director.escalationRate': 'Eskalationsrate',
    'pcb.director.callbackRate': 'Rückrufquote',
    'pcb.director.kpisTitle': 'Wichtige Leistungskennzahlen',
    'pcb.director.avgResolutionTime': 'Durchschnittliche Lösungszeit',
    'pcb.director.avgFirstResponseFull': 'Durchschnittliche Erstreaktion',
    'pcb.director.reopenedTickets': 'Wieder geöffnete Tickets',
    'pcb.director.reopenedConversations': 'Wieder geöffnete Gespräche',
    'pcb.director.openaiUsageRate': 'OpenAI-Nutzungsrate',
    'pcb.director.ofTickets': '{resolved} von {total} Tickets',
    'pcb.director.periodDay': 'Heute',
    'pcb.director.periodWeek': 'Diese Woche',
    'pcb.director.periodMonth': 'Diesen Monat',
    'pcb.director.periodQuarter': 'Dieses Quartal',
    'pcb.director.periodYear': 'Dieses Jahr',

    'pcb.exec.yourBusiness': 'Ihr Unternehmen',
    'pcb.exec.ticketsRequiringHuman': 'Tickets, die menschliches Eingreifen erfordern',
    'pcb.exec.tabOperations': 'Betrieb',
    'pcb.exec.tabAiPerformance': 'KI-Leistung',
    'pcb.exec.tabVoiceChannel': 'Sprachkanal',
    'pcb.exec.tabServiceQuality': 'Servicequalität',
    'pcb.exec.activeTickets': 'Aktive Tickets',
    'pcb.exec.openRightNow': 'Gerade offen',
    'pcb.exec.totalTickets': 'Tickets gesamt',
    'pcb.exec.resolved': 'gelöst',
    'pcb.exec.avgResolution': 'Durchschn. Lösung',
    'pcb.exec.createClose': 'Erstellen → Schließen',
    'pcb.exec.avgFirstResponse': 'Durchschn. Erstreaktion',
    'pcb.exec.firstReply': 'Erste Antwort',
    'pcb.exec.avgChatDuration': 'Durchschn. Chatdauer',
    'pcb.exec.perResolvedConv': 'Pro gelöstem Gespräch',
    'pcb.exec.callbackRate': 'Rückrufquote',
    'pcb.exec.escalationsPendingCallback': 'Eskalationen mit ausstehendem Rückruf',
    'pcb.exec.reopenedConversations': 'Wieder geöffnete Gespräche',
    'pcb.exec.requiredFollowup': 'Nachverfolgung nach Lösung erforderlich',
    'pcb.exec.operatorEscalationDist': 'Verteilung der Eskalationen nach Bediener',
    'pcb.exec.assigned': 'zugewiesen',
    'pcb.exec.aiConversations': 'KI-Gespräche',
    'pcb.exec.autoResolution': 'Autolösung',
    'pcb.exec.avgAiConfidence': 'Durchschn. KI-Konfidenz',
    'pcb.exec.openaiFallbackRate': 'OpenAI-Rückfallrate',
    'pcb.exec.financialMetricsNote': 'Finanzkennzahlen (Umsatz, ROI, CLV, Marktanteil) erfordern eine Abrechnungsintegration. Wenden Sie sich an Ihren Administrator, um Abrechnungsdatenquellen zu konfigurieren.',
    'pcb.exec.csatScore': 'CSAT-Wert',
    'pcb.exec.avgCustomerRating': 'Durchschnittliche Kundenbewertung (Skala 1–5)',
    'pcb.exec.basedOnRatings': 'Basierend auf {count} Kundenbewertungen',
    'pcb.exec.noRatingsCollected': 'Noch keine Bewertungen erfasst — Kunden bewerten nach der Lösung',
    'pcb.exec.resolutionHealth': 'Lösungszustand',
    'pcb.exec.aiResolvedNoHuman': 'Von KI ohne menschliches Eingreifen gelöst',
    'pcb.exec.ticketsResolvedOf': '{resolved} von {total} Tickets gelöst',
    'pcb.exec.noData': 'Keine Daten',
    'pcb.exec.callbackSla': 'Rückruf-SLA',
    'pcb.exec.slaBreaches': 'SLA-Verletzungen (überfällige Rückrufe)',
    'pcb.exec.pendingOverdue': '{pending} ausstehend, {overdue} überfällig',
    'pcb.exec.noVoiceData': 'Keine Sprachdaten',
    'pcb.exec.surveyMetricsNote': 'NPS, Mitarbeiterzufriedenheit und Marktkennzahlen erfordern zusätzliche Integrationen von Umfrage- und Marktdaten. Sie sind aus reinen Betriebsdaten nicht verfügbar.',
    'pcb.exec.responses': 'Antworten',

    'pcb.it.recentEscalations': 'Aktuelle Eskalationen',
    'pcb.it.noRecentEscalations': 'Keine aktuellen Eskalationen.',
    'pcb.it.manageIntegrations': 'Integrationen in den Einstellungen verwalten',
    'pcb.it.escalation': 'Eskalation',
    'pcb.it.justNow': 'gerade eben',
    'pcb.it.minAgo': 'vor {n} Min.',
    'pcb.it.hourAgo': 'vor {n} Std.',
    'pcb.it.dayAgo': 'vor {n} T.',
  },

  it: {
    'pcb.common.success': 'Successo',
    'pcb.common.cancel': 'Annulla',

    'pcb.category.notSet': 'Non impostato',
    'pcb.category.loadingCategories': 'Caricamento delle categorie di feedback...',
    'pcb.category.industry': 'Settore',
    'pcb.category.subSector': 'Sottosettore',
    'pcb.category.addCustom': 'Aggiungi categoria personalizzata',
    'pcb.category.viewAnalytics': 'Visualizza analisi',
    'pcb.category.totalCategories': 'Totale categorie',
    'pcb.category.enabled': 'Abilitata',
    'pcb.category.customized': 'Personalizzata',
    'pcb.category.inherited': 'Ereditata',
    'pcb.category.universal': 'Universale',
    'pcb.category.custom': 'Personalizzata',
    'pcb.category.activeCategories': 'Categorie di feedback attive',
    'pcb.category.activeCategoriesDesc': 'Categorie ereditate dal tuo sottosettore. Personalizza priorità, regole di escalation e parole chiave IA.',
    'pcb.category.noCategories': 'Nessuna categoria trovata',
    'pcb.category.noCategoriesHint': 'Completa il profilo della tua azienda per far assegnare automaticamente le categorie di feedback',
    'pcb.category.escalation': 'Escalation:',
    'pcb.category.sla': 'SLA:',
    'pcb.category.aiKeywords': 'Parole chiave IA:',
    'pcb.category.customKeywords': 'Parole chiave personalizzate:',
    'pcb.category.moreCount': '+{count} altre',
    'pcb.category.disabled': 'Disabilitata',
    'pcb.category.disable': 'Disabilita',
    'pcb.category.enable': 'Abilita',
    'pcb.category.customize': 'Personalizza',
    'pcb.category.deleteCustomTitle': 'Elimina categoria personalizzata',
    'pcb.category.customizeCategory': 'Personalizza categoria',
    'pcb.category.editDialogDesc': 'Personalizza priorità, livello di escalation, SLA e aggiungi parole chiave IA per la tua azienda',
    'pcb.category.note': 'Nota',
    'pcb.category.editNote': 'Le personalizzazioni si applicano solo alla tua azienda. Le impostazioni originali della categoria vengono conservate.',
    'pcb.category.customPriority': 'Priorità personalizzata',
    'pcb.category.defaultLabel': 'Predefinito',
    'pcb.category.useDefault': 'Usa predefinito',
    'pcb.category.low': 'Bassa',
    'pcb.category.medium': 'Media',
    'pcb.category.high': 'Alta',
    'pcb.category.critical': 'Critica',
    'pcb.category.leaveEmptyDefault': 'Lascia vuoto per usare il valore predefinito',
    'pcb.category.customEscalation': 'Livello di escalation personalizzato',
    'pcb.category.setEscalation': 'Imposta livello di escalation',
    'pcb.category.customSlaHours': 'SLA personalizzato (ore)',
    'pcb.category.egSla24': 'es. 24',
    'pcb.category.slaHint': 'Obiettivo di tempo di risposta per questa categoria',
    'pcb.category.additionalKeywords': 'Parole chiave IA aggiuntive (separate da virgole)',
    'pcb.category.keywordsPlaceholder': 'es. frase personalizzata, termine specifico dell\'azienda, gergo del settore',
    'pcb.category.keywordsHint': 'Aggiungi parole chiave specifiche dell\'azienda per aiutare l\'IA a classificare meglio il feedback. Vengono aggiunte alle parole chiave predefinite.',
    'pcb.category.defaultAiKeywords': 'Parole chiave IA predefinite:',
    'pcb.category.saveCustomization': 'Salva personalizzazione',
    'pcb.category.createTitle': 'Crea categoria di feedback personalizzata',
    'pcb.category.createDesc': 'Aggiungi una categoria di feedback unica e specifica per la tua azienda',
    'pcb.category.categoryName': 'Nome della categoria',
    'pcb.category.namePlaceholder': 'es. Gestione ospiti VIP',
    'pcb.category.description': 'Descrizione',
    'pcb.category.descPlaceholder': 'Che tipo di feedback copre questa categoria?',
    'pcb.category.priorityLevel': 'Livello di priorità',
    'pcb.category.escalateTo': 'Inoltra a',
    'pcb.category.slaHours': 'SLA (ore)',
    'pcb.category.aiKeywordsCsv': 'Parole chiave IA (separate da virgole)',
    'pcb.category.keywordsPlaceholder2': 'es. vip, ospite premium, richiesta speciale, concierge',
    'pcb.category.keywordsHint2': 'Le parole chiave aiutano l\'IA a classificare automaticamente il feedback in questa categoria',
    'pcb.category.createCategory': 'Crea categoria',
    'pcb.category.customCreated': 'Categoria personalizzata "{name}" creata con successo per la tua azienda',
    'pcb.category.customRemoved': 'Categoria personalizzata "{name}" rimossa',
    'pcb.category.confirmDelete': 'Eliminare la categoria personalizzata "{name}"? L\'operazione non può essere annullata.',
    'pcb.category.cannotDelete': 'Impossibile eliminare',
    'pcb.category.inheritedCannotDelete': 'Le categorie ereditate/universali possono solo essere disabilitate, non eliminate.',
    'pcb.category.cannotDeleteInherited': 'Le categorie ereditate/universali non possono essere eliminate; disabilitale invece.',
    'pcb.category.notFound': 'Categoria non trovata (già rimossa).',
    'pcb.category.deleted': 'Eliminata',
    'pcb.category.categoryEnabled': 'Categoria abilitata',
    'pcb.category.categoryDisabled': 'Categoria disabilitata',
    'pcb.category.failedSaveCustomization': 'Impossibile salvare la personalizzazione',
    'pcb.category.failedCreateCustom': 'Impossibile creare la categoria personalizzata',
    'pcb.category.failedUpdate': 'Impossibile aggiornare la categoria',
    'pcb.category.failedDelete': 'Impossibile eliminare la categoria',

    'pcb.director.noTicketActivity': 'Nessuna attività di ticket nel periodo selezionato.',
    'pcb.director.ticketStatusDist': 'Distribuzione dello stato dei ticket',
    'pcb.director.noTicketData': 'Nessun dato di ticket nel periodo selezionato.',
    'pcb.director.conversationIntents': 'Intenti delle conversazioni',
    'pcb.director.noIntentData': 'Nessun dato sugli intenti delle conversazioni ancora disponibile.',
    'pcb.director.customerSatisfaction': 'Soddisfazione del cliente',
    'pcb.director.responses': 'risposte',
    'pcb.director.aiAutoResolution': 'Risoluzione automatica IA',
    'pcb.director.resolvedWithoutStaff': 'Risolti senza personale',
    'pcb.director.escalationRate': 'Tasso di escalation',
    'pcb.director.callbackRate': 'Tasso di richiamata',
    'pcb.director.kpisTitle': 'Indicatori chiave di prestazione',
    'pcb.director.avgResolutionTime': 'Tempo medio di risoluzione',
    'pcb.director.avgFirstResponseFull': 'Prima risposta media',
    'pcb.director.reopenedTickets': 'Ticket riaperti',
    'pcb.director.reopenedConversations': 'Conversazioni riaperte',
    'pcb.director.openaiUsageRate': 'Tasso di utilizzo di OpenAI',
    'pcb.director.ofTickets': '{resolved} di {total} ticket',
    'pcb.director.periodDay': 'Oggi',
    'pcb.director.periodWeek': 'Questa settimana',
    'pcb.director.periodMonth': 'Questo mese',
    'pcb.director.periodQuarter': 'Questo trimestre',
    'pcb.director.periodYear': 'Quest\'anno',

    'pcb.exec.yourBusiness': 'La tua azienda',
    'pcb.exec.ticketsRequiringHuman': 'Ticket che richiedono intervento umano',
    'pcb.exec.tabOperations': 'Operazioni',
    'pcb.exec.tabAiPerformance': 'Prestazioni IA',
    'pcb.exec.tabVoiceChannel': 'Canale vocale',
    'pcb.exec.tabServiceQuality': 'Qualità del servizio',
    'pcb.exec.activeTickets': 'Ticket attivi',
    'pcb.exec.openRightNow': 'Aperti in questo momento',
    'pcb.exec.totalTickets': 'Totale ticket',
    'pcb.exec.resolved': 'risolti',
    'pcb.exec.avgResolution': 'Risoluzione media',
    'pcb.exec.createClose': 'Creazione → chiusura',
    'pcb.exec.avgFirstResponse': 'Prima risposta media',
    'pcb.exec.firstReply': 'Prima risposta',
    'pcb.exec.avgChatDuration': 'Durata media chat',
    'pcb.exec.perResolvedConv': 'Per conversazione risolta',
    'pcb.exec.callbackRate': 'Tasso di richiamata',
    'pcb.exec.escalationsPendingCallback': 'Escalation in attesa di richiamata',
    'pcb.exec.reopenedConversations': 'Conversazioni riaperte',
    'pcb.exec.requiredFollowup': 'Follow-up necessario dopo la risoluzione',
    'pcb.exec.operatorEscalationDist': 'Distribuzione delle escalation per operatore',
    'pcb.exec.assigned': 'assegnati',
    'pcb.exec.aiConversations': 'Conversazioni IA',
    'pcb.exec.autoResolution': 'Risoluzione automatica',
    'pcb.exec.avgAiConfidence': 'Confidenza media IA',
    'pcb.exec.openaiFallbackRate': 'Tasso di ricorso a OpenAI',
    'pcb.exec.financialMetricsNote': 'Le metriche finanziarie (ricavi, ROI, CLV, quota di mercato) richiedono l\'integrazione della fatturazione. Contatta l\'amministratore per configurare le origini dati di fatturazione.',
    'pcb.exec.csatScore': 'Punteggio CSAT',
    'pcb.exec.avgCustomerRating': 'Valutazione media dei clienti (scala 1–5)',
    'pcb.exec.basedOnRatings': 'In base a {count} valutazioni dei clienti',
    'pcb.exec.noRatingsCollected': 'Nessuna valutazione ancora raccolta — i clienti valutano dopo la risoluzione',
    'pcb.exec.resolutionHealth': 'Stato della risoluzione',
    'pcb.exec.aiResolvedNoHuman': 'Risolto dall\'IA senza intervento umano',
    'pcb.exec.ticketsResolvedOf': '{resolved} di {total} ticket risolti',
    'pcb.exec.noData': 'Nessun dato',
    'pcb.exec.callbackSla': 'SLA di richiamata',
    'pcb.exec.slaBreaches': 'Violazioni SLA (richiamate scadute)',
    'pcb.exec.pendingOverdue': '{pending} in attesa, {overdue} scadute',
    'pcb.exec.noVoiceData': 'Nessun dato vocale',
    'pcb.exec.surveyMetricsNote': 'NPS, soddisfazione dei dipendenti e metriche di mercato richiedono ulteriori integrazioni di dati di sondaggi e di mercato. Non sono disponibili solo dai dati operativi.',
    'pcb.exec.responses': 'risposte',

    'pcb.it.recentEscalations': 'Escalation recenti',
    'pcb.it.noRecentEscalations': 'Nessuna escalation recente.',
    'pcb.it.manageIntegrations': 'Gestisci integrazioni nelle Impostazioni',
    'pcb.it.escalation': 'Escalation',
    'pcb.it.justNow': 'proprio ora',
    'pcb.it.minAgo': '{n} min fa',
    'pcb.it.hourAgo': '{n} h fa',
    'pcb.it.dayAgo': '{n} g fa',
  },

  ja: {
    'pcb.common.success': '成功',
    'pcb.common.cancel': 'キャンセル',

    'pcb.category.notSet': '未設定',
    'pcb.category.loadingCategories': 'フィードバックカテゴリを読み込んでいます...',
    'pcb.category.industry': '業種',
    'pcb.category.subSector': 'サブセクター',
    'pcb.category.addCustom': 'カスタムカテゴリを追加',
    'pcb.category.viewAnalytics': '分析を表示',
    'pcb.category.totalCategories': 'カテゴリ合計',
    'pcb.category.enabled': '有効',
    'pcb.category.customized': 'カスタマイズ済み',
    'pcb.category.inherited': '継承',
    'pcb.category.universal': '共通',
    'pcb.category.custom': 'カスタム',
    'pcb.category.activeCategories': '有効なフィードバックカテゴリ',
    'pcb.category.activeCategoriesDesc': 'サブセクターから継承されたカテゴリです。優先度、エスカレーションルール、AIキーワードをカスタマイズできます。',
    'pcb.category.noCategories': 'カテゴリが見つかりません',
    'pcb.category.noCategoriesHint': 'ビジネスプロフィールを完成させると、フィードバックカテゴリが自動的に割り当てられます',
    'pcb.category.escalation': 'エスカレーション:',
    'pcb.category.sla': 'SLA:',
    'pcb.category.aiKeywords': 'AIキーワード:',
    'pcb.category.customKeywords': 'カスタムキーワード:',
    'pcb.category.moreCount': '他 +{count} 件',
    'pcb.category.disabled': '無効',
    'pcb.category.disable': '無効にする',
    'pcb.category.enable': '有効にする',
    'pcb.category.customize': 'カスタマイズ',
    'pcb.category.deleteCustomTitle': 'カスタムカテゴリを削除',
    'pcb.category.customizeCategory': 'カテゴリをカスタマイズ',
    'pcb.category.editDialogDesc': '優先度、エスカレーションレベル、SLAをカスタマイズし、ビジネス向けのカスタムAIキーワードを追加します',
    'pcb.category.note': '注意',
    'pcb.category.editNote': 'カスタマイズは自社にのみ適用されます。元のカテゴリ設定は保持されます。',
    'pcb.category.customPriority': 'カスタム優先度',
    'pcb.category.defaultLabel': 'デフォルト',
    'pcb.category.useDefault': 'デフォルトを使用',
    'pcb.category.low': '低',
    'pcb.category.medium': '中',
    'pcb.category.high': '高',
    'pcb.category.critical': '重大',
    'pcb.category.leaveEmptyDefault': '空欄のままにするとデフォルトを使用します',
    'pcb.category.customEscalation': 'カスタムエスカレーションレベル',
    'pcb.category.setEscalation': 'エスカレーションレベルを設定',
    'pcb.category.customSlaHours': 'カスタムSLA（時間）',
    'pcb.category.egSla24': '例: 24',
    'pcb.category.slaHint': 'このカテゴリの応答時間目標',
    'pcb.category.additionalKeywords': '追加のAIキーワード（カンマ区切り）',
    'pcb.category.keywordsPlaceholder': '例: カスタムフレーズ、業務固有の用語、業界用語',
    'pcb.category.keywordsHint': 'AIがフィードバックをより適切に分類できるよう、業務固有のキーワードを追加します。これらはデフォルトのキーワードに追加されます。',
    'pcb.category.defaultAiKeywords': 'デフォルトのAIキーワード:',
    'pcb.category.saveCustomization': 'カスタマイズを保存',
    'pcb.category.createTitle': 'カスタムフィードバックカテゴリを作成',
    'pcb.category.createDesc': '自社専用の独自のフィードバックカテゴリを追加します',
    'pcb.category.categoryName': 'カテゴリ名',
    'pcb.category.namePlaceholder': '例: VIPゲスト対応',
    'pcb.category.description': '説明',
    'pcb.category.descPlaceholder': 'このカテゴリはどのようなフィードバックを対象としますか？',
    'pcb.category.priorityLevel': '優先度レベル',
    'pcb.category.escalateTo': 'エスカレーション先',
    'pcb.category.slaHours': 'SLA（時間）',
    'pcb.category.aiKeywordsCsv': 'AIキーワード（カンマ区切り）',
    'pcb.category.keywordsPlaceholder2': '例: vip、プレミアムゲスト、特別リクエスト、コンシェルジュ',
    'pcb.category.keywordsHint2': 'キーワードは、AIがフィードバックをこのカテゴリに自動的に分類するのに役立ちます',
    'pcb.category.createCategory': 'カテゴリを作成',
    'pcb.category.customCreated': 'カスタムカテゴリ「{name}」を自社向けに作成しました',
    'pcb.category.customRemoved': 'カスタムカテゴリ「{name}」を削除しました',
    'pcb.category.confirmDelete': 'カスタムカテゴリ「{name}」を削除しますか？この操作は元に戻せません。',
    'pcb.category.cannotDelete': '削除できません',
    'pcb.category.inheritedCannotDelete': '継承／共通のカテゴリは無効化のみ可能で、削除はできません。',
    'pcb.category.cannotDeleteInherited': '継承／共通のカテゴリは削除できません。代わりに無効化してください。',
    'pcb.category.notFound': 'カテゴリが見つかりません（すでに削除済み）。',
    'pcb.category.deleted': '削除済み',
    'pcb.category.categoryEnabled': 'カテゴリを有効にしました',
    'pcb.category.categoryDisabled': 'カテゴリを無効にしました',
    'pcb.category.failedSaveCustomization': 'カスタマイズの保存に失敗しました',
    'pcb.category.failedCreateCustom': 'カスタムカテゴリの作成に失敗しました',
    'pcb.category.failedUpdate': 'カテゴリの更新に失敗しました',
    'pcb.category.failedDelete': 'カテゴリの削除に失敗しました',

    'pcb.director.noTicketActivity': '選択した期間にチケットのアクティビティはありません。',
    'pcb.director.ticketStatusDist': 'チケットステータスの分布',
    'pcb.director.noTicketData': '選択した期間にチケットデータはありません。',
    'pcb.director.conversationIntents': '会話の意図',
    'pcb.director.noIntentData': '会話の意図に関するデータはまだありません。',
    'pcb.director.customerSatisfaction': '顧客満足度',
    'pcb.director.responses': '件の回答',
    'pcb.director.aiAutoResolution': 'AI自動解決',
    'pcb.director.resolvedWithoutStaff': 'スタッフなしで解決',
    'pcb.director.escalationRate': 'エスカレーション率',
    'pcb.director.callbackRate': 'コールバック率',
    'pcb.director.kpisTitle': '主要業績評価指標',
    'pcb.director.avgResolutionTime': '平均解決時間',
    'pcb.director.avgFirstResponseFull': '平均初回応答',
    'pcb.director.reopenedTickets': '再オープンしたチケット',
    'pcb.director.reopenedConversations': '再オープンした会話',
    'pcb.director.openaiUsageRate': 'OpenAI利用率',
    'pcb.director.ofTickets': '{total} 件中 {resolved} 件のチケット',
    'pcb.director.periodDay': '今日',
    'pcb.director.periodWeek': '今週',
    'pcb.director.periodMonth': '今月',
    'pcb.director.periodQuarter': '今四半期',
    'pcb.director.periodYear': '今年',

    'pcb.exec.yourBusiness': 'あなたのビジネス',
    'pcb.exec.ticketsRequiringHuman': '人による対応が必要なチケット',
    'pcb.exec.tabOperations': '運用',
    'pcb.exec.tabAiPerformance': 'AIパフォーマンス',
    'pcb.exec.tabVoiceChannel': '音声チャネル',
    'pcb.exec.tabServiceQuality': 'サービス品質',
    'pcb.exec.activeTickets': 'アクティブなチケット',
    'pcb.exec.openRightNow': '現在オープン中',
    'pcb.exec.totalTickets': 'チケット合計',
    'pcb.exec.resolved': '件解決',
    'pcb.exec.avgResolution': '平均解決',
    'pcb.exec.createClose': '作成 → クローズ',
    'pcb.exec.avgFirstResponse': '平均初回応答',
    'pcb.exec.firstReply': '初回返信',
    'pcb.exec.avgChatDuration': '平均チャット時間',
    'pcb.exec.perResolvedConv': '解決済み会話あたり',
    'pcb.exec.callbackRate': 'コールバック率',
    'pcb.exec.escalationsPendingCallback': 'コールバック待ちのエスカレーション',
    'pcb.exec.reopenedConversations': '再オープンした会話',
    'pcb.exec.requiredFollowup': '解決後のフォローアップが必要',
    'pcb.exec.operatorEscalationDist': 'オペレーター別エスカレーション分布',
    'pcb.exec.assigned': '件割り当て',
    'pcb.exec.aiConversations': 'AI会話',
    'pcb.exec.autoResolution': '自動解決',
    'pcb.exec.avgAiConfidence': '平均AI信頼度',
    'pcb.exec.openaiFallbackRate': 'OpenAIフォールバック率',
    'pcb.exec.financialMetricsNote': '財務指標（収益、ROI、CLV、市場シェア）には請求システムの連携が必要です。請求データソースを設定するには管理者にお問い合わせください。',
    'pcb.exec.csatScore': 'CSATスコア',
    'pcb.exec.avgCustomerRating': '平均顧客評価（1〜5段階）',
    'pcb.exec.basedOnRatings': '{count} 件の顧客評価に基づく',
    'pcb.exec.noRatingsCollected': 'まだ評価は収集されていません — 顧客は解決後に評価します',
    'pcb.exec.resolutionHealth': '解決の健全性',
    'pcb.exec.aiResolvedNoHuman': '人の介入なしでAIが解決',
    'pcb.exec.ticketsResolvedOf': '{total} 件中 {resolved} 件のチケットを解決',
    'pcb.exec.noData': 'データなし',
    'pcb.exec.callbackSla': 'コールバックSLA',
    'pcb.exec.slaBreaches': 'SLA違反（期限超過のコールバック）',
    'pcb.exec.pendingOverdue': '{pending} 件保留中、{overdue} 件期限超過',
    'pcb.exec.noVoiceData': '音声データなし',
    'pcb.exec.surveyMetricsNote': 'NPS、従業員満足度、市場指標には、追加のアンケートおよび市場データ連携が必要です。運用データのみからは利用できません。',
    'pcb.exec.responses': '件の回答',

    'pcb.it.recentEscalations': '最近のエスカレーション',
    'pcb.it.noRecentEscalations': '最近のエスカレーションはありません。',
    'pcb.it.manageIntegrations': '設定で連携を管理',
    'pcb.it.escalation': 'エスカレーション',
    'pcb.it.justNow': 'たった今',
    'pcb.it.minAgo': '{n}分前',
    'pcb.it.hourAgo': '{n}時間前',
    'pcb.it.dayAgo': '{n}日前',
  },

  ko: {
    'pcb.common.success': '성공',
    'pcb.common.cancel': '취소',

    'pcb.category.notSet': '설정되지 않음',
    'pcb.category.loadingCategories': '피드백 카테고리를 불러오는 중...',
    'pcb.category.industry': '업종',
    'pcb.category.subSector': '하위 부문',
    'pcb.category.addCustom': '맞춤 카테고리 추가',
    'pcb.category.viewAnalytics': '분석 보기',
    'pcb.category.totalCategories': '전체 카테고리',
    'pcb.category.enabled': '활성화됨',
    'pcb.category.customized': '맞춤 설정됨',
    'pcb.category.inherited': '상속됨',
    'pcb.category.universal': '공통',
    'pcb.category.custom': '맞춤',
    'pcb.category.activeCategories': '활성 피드백 카테고리',
    'pcb.category.activeCategoriesDesc': '하위 부문에서 상속된 카테고리입니다. 우선순위, 에스컬레이션 규칙, AI 키워드를 맞춤 설정하세요.',
    'pcb.category.noCategories': '카테고리를 찾을 수 없습니다',
    'pcb.category.noCategoriesHint': '비즈니스 프로필을 완성하면 피드백 카테고리가 자동으로 할당됩니다',
    'pcb.category.escalation': '에스컬레이션:',
    'pcb.category.sla': 'SLA:',
    'pcb.category.aiKeywords': 'AI 키워드:',
    'pcb.category.customKeywords': '맞춤 키워드:',
    'pcb.category.moreCount': '+{count}개 더',
    'pcb.category.disabled': '비활성화됨',
    'pcb.category.disable': '비활성화',
    'pcb.category.enable': '활성화',
    'pcb.category.customize': '맞춤 설정',
    'pcb.category.deleteCustomTitle': '맞춤 카테고리 삭제',
    'pcb.category.customizeCategory': '카테고리 맞춤 설정',
    'pcb.category.editDialogDesc': '우선순위, 에스컬레이션 수준, SLA를 맞춤 설정하고 비즈니스용 맞춤 AI 키워드를 추가하세요',
    'pcb.category.note': '참고',
    'pcb.category.editNote': '맞춤 설정은 귀하의 비즈니스에만 적용됩니다. 원래 카테고리 설정은 유지됩니다.',
    'pcb.category.customPriority': '맞춤 우선순위',
    'pcb.category.defaultLabel': '기본값',
    'pcb.category.useDefault': '기본값 사용',
    'pcb.category.low': '낮음',
    'pcb.category.medium': '보통',
    'pcb.category.high': '높음',
    'pcb.category.critical': '심각',
    'pcb.category.leaveEmptyDefault': '기본값을 사용하려면 비워 두세요',
    'pcb.category.customEscalation': '맞춤 에스컬레이션 수준',
    'pcb.category.setEscalation': '에스컬레이션 수준 설정',
    'pcb.category.customSlaHours': '맞춤 SLA(시간)',
    'pcb.category.egSla24': '예: 24',
    'pcb.category.slaHint': '이 카테고리의 응답 시간 목표',
    'pcb.category.additionalKeywords': '추가 AI 키워드(쉼표로 구분)',
    'pcb.category.keywordsPlaceholder': '예: 맞춤 문구, 비즈니스 전용 용어, 업계 전문 용어',
    'pcb.category.keywordsHint': 'AI가 피드백을 더 잘 분류하도록 비즈니스 전용 키워드를 추가하세요. 기본 키워드에 추가됩니다.',
    'pcb.category.defaultAiKeywords': '기본 AI 키워드:',
    'pcb.category.saveCustomization': '맞춤 설정 저장',
    'pcb.category.createTitle': '맞춤 피드백 카테고리 만들기',
    'pcb.category.createDesc': '비즈니스에 특화된 고유한 피드백 카테고리를 추가하세요',
    'pcb.category.categoryName': '카테고리 이름',
    'pcb.category.namePlaceholder': '예: VIP 고객 응대',
    'pcb.category.description': '설명',
    'pcb.category.descPlaceholder': '이 카테고리는 어떤 유형의 피드백을 다루나요?',
    'pcb.category.priorityLevel': '우선순위 수준',
    'pcb.category.escalateTo': '에스컬레이션 대상',
    'pcb.category.slaHours': 'SLA(시간)',
    'pcb.category.aiKeywordsCsv': 'AI 키워드(쉼표로 구분)',
    'pcb.category.keywordsPlaceholder2': '예: vip, 프리미엄 고객, 특별 요청, 컨시어지',
    'pcb.category.keywordsHint2': '키워드는 AI가 피드백을 이 카테고리로 자동 분류하는 데 도움이 됩니다',
    'pcb.category.createCategory': '카테고리 만들기',
    'pcb.category.customCreated': '맞춤 카테고리 "{name}"이(가) 귀하의 비즈니스에 성공적으로 생성되었습니다',
    'pcb.category.customRemoved': '맞춤 카테고리 "{name}"이(가) 제거되었습니다',
    'pcb.category.confirmDelete': '맞춤 카테고리 "{name}"을(를) 삭제하시겠습니까? 이 작업은 취소할 수 없습니다.',
    'pcb.category.cannotDelete': '삭제할 수 없음',
    'pcb.category.inheritedCannotDelete': '상속/공통 카테고리는 비활성화만 가능하며 삭제할 수 없습니다.',
    'pcb.category.cannotDeleteInherited': '상속/공통 카테고리는 삭제할 수 없습니다. 대신 비활성화하세요.',
    'pcb.category.notFound': '카테고리를 찾을 수 없습니다(이미 제거됨).',
    'pcb.category.deleted': '삭제됨',
    'pcb.category.categoryEnabled': '카테고리가 활성화되었습니다',
    'pcb.category.categoryDisabled': '카테고리가 비활성화되었습니다',
    'pcb.category.failedSaveCustomization': '맞춤 설정을 저장하지 못했습니다',
    'pcb.category.failedCreateCustom': '맞춤 카테고리를 생성하지 못했습니다',
    'pcb.category.failedUpdate': '카테고리를 업데이트하지 못했습니다',
    'pcb.category.failedDelete': '카테고리를 삭제하지 못했습니다',

    'pcb.director.noTicketActivity': '선택한 기간에 티켓 활동이 없습니다.',
    'pcb.director.ticketStatusDist': '티켓 상태 분포',
    'pcb.director.noTicketData': '선택한 기간에 티켓 데이터가 없습니다.',
    'pcb.director.conversationIntents': '대화 의도',
    'pcb.director.noIntentData': '아직 대화 의도 데이터가 없습니다.',
    'pcb.director.customerSatisfaction': '고객 만족도',
    'pcb.director.responses': '개 응답',
    'pcb.director.aiAutoResolution': 'AI 자동 해결',
    'pcb.director.resolvedWithoutStaff': '직원 없이 해결됨',
    'pcb.director.escalationRate': '에스컬레이션 비율',
    'pcb.director.callbackRate': '콜백 비율',
    'pcb.director.kpisTitle': '핵심 성과 지표',
    'pcb.director.avgResolutionTime': '평균 해결 시간',
    'pcb.director.avgFirstResponseFull': '평균 첫 응답',
    'pcb.director.reopenedTickets': '재오픈된 티켓',
    'pcb.director.reopenedConversations': '재오픈된 대화',
    'pcb.director.openaiUsageRate': 'OpenAI 사용률',
    'pcb.director.ofTickets': '{total}개 중 {resolved}개 티켓',
    'pcb.director.periodDay': '오늘',
    'pcb.director.periodWeek': '이번 주',
    'pcb.director.periodMonth': '이번 달',
    'pcb.director.periodQuarter': '이번 분기',
    'pcb.director.periodYear': '올해',

    'pcb.exec.yourBusiness': '내 비즈니스',
    'pcb.exec.ticketsRequiringHuman': '사람의 대응이 필요한 티켓',
    'pcb.exec.tabOperations': '운영',
    'pcb.exec.tabAiPerformance': 'AI 성능',
    'pcb.exec.tabVoiceChannel': '음성 채널',
    'pcb.exec.tabServiceQuality': '서비스 품질',
    'pcb.exec.activeTickets': '활성 티켓',
    'pcb.exec.openRightNow': '현재 열림',
    'pcb.exec.totalTickets': '전체 티켓',
    'pcb.exec.resolved': '개 해결됨',
    'pcb.exec.avgResolution': '평균 해결',
    'pcb.exec.createClose': '생성 → 종료',
    'pcb.exec.avgFirstResponse': '평균 첫 응답',
    'pcb.exec.firstReply': '첫 응답',
    'pcb.exec.avgChatDuration': '평균 채팅 시간',
    'pcb.exec.perResolvedConv': '해결된 대화당',
    'pcb.exec.callbackRate': '콜백 비율',
    'pcb.exec.escalationsPendingCallback': '콜백 대기 중인 에스컬레이션',
    'pcb.exec.reopenedConversations': '재오픈된 대화',
    'pcb.exec.requiredFollowup': '해결 후 후속 조치 필요',
    'pcb.exec.operatorEscalationDist': '운영자별 에스컬레이션 분포',
    'pcb.exec.assigned': '개 할당됨',
    'pcb.exec.aiConversations': 'AI 대화',
    'pcb.exec.autoResolution': '자동 해결',
    'pcb.exec.avgAiConfidence': '평균 AI 신뢰도',
    'pcb.exec.openaiFallbackRate': 'OpenAI 폴백 비율',
    'pcb.exec.financialMetricsNote': '재무 지표(수익, ROI, CLV, 시장 점유율)에는 결제 연동이 필요합니다. 결제 데이터 소스를 구성하려면 관리자에게 문의하세요.',
    'pcb.exec.csatScore': 'CSAT 점수',
    'pcb.exec.avgCustomerRating': '평균 고객 평가(1~5점 척도)',
    'pcb.exec.basedOnRatings': '{count}개의 고객 평가 기준',
    'pcb.exec.noRatingsCollected': '아직 수집된 평가가 없습니다 — 고객은 해결 후 평가합니다',
    'pcb.exec.resolutionHealth': '해결 상태',
    'pcb.exec.aiResolvedNoHuman': '사람의 개입 없이 AI가 해결',
    'pcb.exec.ticketsResolvedOf': '{total}개 중 {resolved}개 티켓 해결됨',
    'pcb.exec.noData': '데이터 없음',
    'pcb.exec.callbackSla': '콜백 SLA',
    'pcb.exec.slaBreaches': 'SLA 위반(기한 초과 콜백)',
    'pcb.exec.pendingOverdue': '{pending}개 대기 중, {overdue}개 기한 초과',
    'pcb.exec.noVoiceData': '음성 데이터 없음',
    'pcb.exec.surveyMetricsNote': 'NPS, 직원 만족도, 시장 지표에는 추가 설문 및 시장 데이터 연동이 필요합니다. 운영 데이터만으로는 제공되지 않습니다.',
    'pcb.exec.responses': '개 응답',

    'pcb.it.recentEscalations': '최근 에스컬레이션',
    'pcb.it.noRecentEscalations': '최근 에스컬레이션이 없습니다.',
    'pcb.it.manageIntegrations': '설정에서 연동 관리',
    'pcb.it.escalation': '에스컬레이션',
    'pcb.it.justNow': '방금 전',
    'pcb.it.minAgo': '{n}분 전',
    'pcb.it.hourAgo': '{n}시간 전',
    'pcb.it.dayAgo': '{n}일 전',
  },

  zh: {
    'pcb.common.success': '成功',
    'pcb.common.cancel': '取消',

    'pcb.category.notSet': '未设置',
    'pcb.category.loadingCategories': '正在加载反馈类别...',
    'pcb.category.industry': '行业',
    'pcb.category.subSector': '子行业',
    'pcb.category.addCustom': '添加自定义类别',
    'pcb.category.viewAnalytics': '查看分析',
    'pcb.category.totalCategories': '类别总数',
    'pcb.category.enabled': '已启用',
    'pcb.category.customized': '已自定义',
    'pcb.category.inherited': '继承',
    'pcb.category.universal': '通用',
    'pcb.category.custom': '自定义',
    'pcb.category.activeCategories': '活动反馈类别',
    'pcb.category.activeCategoriesDesc': '从您的子行业继承的类别。可自定义优先级、升级规则和 AI 关键词。',
    'pcb.category.noCategories': '未找到类别',
    'pcb.category.noCategoriesHint': '完善您的企业资料，即可自动分配反馈类别',
    'pcb.category.escalation': '升级：',
    'pcb.category.sla': 'SLA：',
    'pcb.category.aiKeywords': 'AI 关键词：',
    'pcb.category.customKeywords': '自定义关键词：',
    'pcb.category.moreCount': '还有 +{count} 个',
    'pcb.category.disabled': '已禁用',
    'pcb.category.disable': '禁用',
    'pcb.category.enable': '启用',
    'pcb.category.customize': '自定义',
    'pcb.category.deleteCustomTitle': '删除自定义类别',
    'pcb.category.customizeCategory': '自定义类别',
    'pcb.category.editDialogDesc': '自定义优先级、升级级别和 SLA，并为您的企业添加自定义 AI 关键词',
    'pcb.category.note': '注意',
    'pcb.category.editNote': '自定义仅适用于您的企业。原始类别设置会被保留。',
    'pcb.category.customPriority': '自定义优先级',
    'pcb.category.defaultLabel': '默认',
    'pcb.category.useDefault': '使用默认值',
    'pcb.category.low': '低',
    'pcb.category.medium': '中',
    'pcb.category.high': '高',
    'pcb.category.critical': '严重',
    'pcb.category.leaveEmptyDefault': '留空则使用默认值',
    'pcb.category.customEscalation': '自定义升级级别',
    'pcb.category.setEscalation': '设置升级级别',
    'pcb.category.customSlaHours': '自定义 SLA（小时）',
    'pcb.category.egSla24': '例如：24',
    'pcb.category.slaHint': '此类别的响应时间目标',
    'pcb.category.additionalKeywords': '其他 AI 关键词（用逗号分隔）',
    'pcb.category.keywordsPlaceholder': '例如：自定义短语、企业专用术语、行业术语',
    'pcb.category.keywordsHint': '添加企业专用关键词，帮助 AI 更好地分类反馈。这些将添加到默认关键词中。',
    'pcb.category.defaultAiKeywords': '默认 AI 关键词：',
    'pcb.category.saveCustomization': '保存自定义',
    'pcb.category.createTitle': '创建自定义反馈类别',
    'pcb.category.createDesc': '添加专属于您企业的独特反馈类别',
    'pcb.category.categoryName': '类别名称',
    'pcb.category.namePlaceholder': '例如：VIP 客户接待',
    'pcb.category.description': '描述',
    'pcb.category.descPlaceholder': '此类别涵盖哪种类型的反馈？',
    'pcb.category.priorityLevel': '优先级',
    'pcb.category.escalateTo': '升级至',
    'pcb.category.slaHours': 'SLA（小时）',
    'pcb.category.aiKeywordsCsv': 'AI 关键词（用逗号分隔）',
    'pcb.category.keywordsPlaceholder2': '例如：vip、高级客户、特殊请求、礼宾',
    'pcb.category.keywordsHint2': '关键词有助于 AI 自动将反馈归入此类别',
    'pcb.category.createCategory': '创建类别',
    'pcb.category.customCreated': '已成功为您的企业创建自定义类别“{name}”',
    'pcb.category.customRemoved': '已删除自定义类别“{name}”',
    'pcb.category.confirmDelete': '删除自定义类别“{name}”？此操作无法撤消。',
    'pcb.category.cannotDelete': '无法删除',
    'pcb.category.inheritedCannotDelete': '继承/通用类别只能禁用，不能删除。',
    'pcb.category.cannotDeleteInherited': '继承/通用类别无法删除；请改为禁用。',
    'pcb.category.notFound': '未找到类别（已被删除）。',
    'pcb.category.deleted': '已删除',
    'pcb.category.categoryEnabled': '类别已启用',
    'pcb.category.categoryDisabled': '类别已禁用',
    'pcb.category.failedSaveCustomization': '保存自定义失败',
    'pcb.category.failedCreateCustom': '创建自定义类别失败',
    'pcb.category.failedUpdate': '更新类别失败',
    'pcb.category.failedDelete': '删除类别失败',

    'pcb.director.noTicketActivity': '所选期间内没有工单活动。',
    'pcb.director.ticketStatusDist': '工单状态分布',
    'pcb.director.noTicketData': '所选期间内没有工单数据。',
    'pcb.director.conversationIntents': '会话意图',
    'pcb.director.noIntentData': '暂无会话意图数据。',
    'pcb.director.customerSatisfaction': '客户满意度',
    'pcb.director.responses': '条回复',
    'pcb.director.aiAutoResolution': 'AI 自动解决',
    'pcb.director.resolvedWithoutStaff': '无需人工即解决',
    'pcb.director.escalationRate': '升级率',
    'pcb.director.callbackRate': '回拨率',
    'pcb.director.kpisTitle': '关键绩效指标',
    'pcb.director.avgResolutionTime': '平均解决时间',
    'pcb.director.avgFirstResponseFull': '平均首次响应',
    'pcb.director.reopenedTickets': '重新打开的工单',
    'pcb.director.reopenedConversations': '重新打开的会话',
    'pcb.director.openaiUsageRate': 'OpenAI 使用率',
    'pcb.director.ofTickets': '{total} 个工单中的 {resolved} 个',
    'pcb.director.periodDay': '今天',
    'pcb.director.periodWeek': '本周',
    'pcb.director.periodMonth': '本月',
    'pcb.director.periodQuarter': '本季度',
    'pcb.director.periodYear': '今年',

    'pcb.exec.yourBusiness': '您的企业',
    'pcb.exec.ticketsRequiringHuman': '需要人工处理的工单',
    'pcb.exec.tabOperations': '运营',
    'pcb.exec.tabAiPerformance': 'AI 性能',
    'pcb.exec.tabVoiceChannel': '语音渠道',
    'pcb.exec.tabServiceQuality': '服务质量',
    'pcb.exec.activeTickets': '活动工单',
    'pcb.exec.openRightNow': '当前打开',
    'pcb.exec.totalTickets': '工单总数',
    'pcb.exec.resolved': '个已解决',
    'pcb.exec.avgResolution': '平均解决',
    'pcb.exec.createClose': '创建 → 关闭',
    'pcb.exec.avgFirstResponse': '平均首次响应',
    'pcb.exec.firstReply': '首次回复',
    'pcb.exec.avgChatDuration': '平均聊天时长',
    'pcb.exec.perResolvedConv': '每个已解决会话',
    'pcb.exec.callbackRate': '回拨率',
    'pcb.exec.escalationsPendingCallback': '待回拨的升级',
    'pcb.exec.reopenedConversations': '重新打开的会话',
    'pcb.exec.requiredFollowup': '解决后需要跟进',
    'pcb.exec.operatorEscalationDist': '按操作员划分的升级分布',
    'pcb.exec.assigned': '个已分配',
    'pcb.exec.aiConversations': 'AI 会话',
    'pcb.exec.autoResolution': '自动解决',
    'pcb.exec.avgAiConfidence': '平均 AI 置信度',
    'pcb.exec.openaiFallbackRate': 'OpenAI 回退率',
    'pcb.exec.financialMetricsNote': '财务指标（收入、投资回报率、客户终身价值、市场份额）需要计费集成。请联系管理员配置计费数据源。',
    'pcb.exec.csatScore': 'CSAT 得分',
    'pcb.exec.avgCustomerRating': '平均客户评分（1–5 分制）',
    'pcb.exec.basedOnRatings': '基于 {count} 条客户评分',
    'pcb.exec.noRatingsCollected': '尚未收集到评分——客户在问题解决后进行评分',
    'pcb.exec.resolutionHealth': '解决健康度',
    'pcb.exec.aiResolvedNoHuman': '由 AI 解决，无需人工干预',
    'pcb.exec.ticketsResolvedOf': '{total} 个工单中已解决 {resolved} 个',
    'pcb.exec.noData': '无数据',
    'pcb.exec.callbackSla': '回拨 SLA',
    'pcb.exec.slaBreaches': 'SLA 违规（逾期回拨）',
    'pcb.exec.pendingOverdue': '{pending} 个待处理，{overdue} 个逾期',
    'pcb.exec.noVoiceData': '无语音数据',
    'pcb.exec.surveyMetricsNote': 'NPS、员工满意度和市场指标需要额外的调查和市场数据集成。仅凭运营数据无法提供这些指标。',
    'pcb.exec.responses': '条回复',

    'pcb.it.recentEscalations': '最近的升级',
    'pcb.it.noRecentEscalations': '暂无最近的升级。',
    'pcb.it.manageIntegrations': '在设置中管理集成',
    'pcb.it.escalation': '升级',
    'pcb.it.justNow': '刚刚',
    'pcb.it.minAgo': '{n} 分钟前',
    'pcb.it.hourAgo': '{n} 小时前',
    'pcb.it.dayAgo': '{n} 天前',
  },

  ar: {
    'pcb.common.success': 'نجاح',
    'pcb.common.cancel': 'إلغاء',

    'pcb.category.notSet': 'غير محدد',
    'pcb.category.loadingCategories': 'جارٍ تحميل فئات الملاحظات...',
    'pcb.category.industry': 'الصناعة',
    'pcb.category.subSector': 'القطاع الفرعي',
    'pcb.category.addCustom': 'إضافة فئة مخصصة',
    'pcb.category.viewAnalytics': 'عرض التحليلات',
    'pcb.category.totalCategories': 'إجمالي الفئات',
    'pcb.category.enabled': 'مُفعّلة',
    'pcb.category.customized': 'مخصّصة',
    'pcb.category.inherited': 'موروثة',
    'pcb.category.universal': 'عامة',
    'pcb.category.custom': 'مخصّصة',
    'pcb.category.activeCategories': 'فئات الملاحظات النشطة',
    'pcb.category.activeCategoriesDesc': 'فئات موروثة من قطاعك الفرعي. خصّص الأولويات وقواعد التصعيد والكلمات المفتاحية للذكاء الاصطناعي.',
    'pcb.category.noCategories': 'لم يتم العثور على فئات',
    'pcb.category.noCategoriesHint': 'أكمل ملف نشاطك التجاري لتُسنَد فئات الملاحظات تلقائيًا',
    'pcb.category.escalation': 'التصعيد:',
    'pcb.category.sla': 'اتفاقية مستوى الخدمة:',
    'pcb.category.aiKeywords': 'الكلمات المفتاحية للذكاء الاصطناعي:',
    'pcb.category.customKeywords': 'الكلمات المفتاحية المخصصة:',
    'pcb.category.moreCount': '+{count} أخرى',
    'pcb.category.disabled': 'معطّلة',
    'pcb.category.disable': 'تعطيل',
    'pcb.category.enable': 'تفعيل',
    'pcb.category.customize': 'تخصيص',
    'pcb.category.deleteCustomTitle': 'حذف الفئة المخصصة',
    'pcb.category.customizeCategory': 'تخصيص الفئة',
    'pcb.category.editDialogDesc': 'خصّص الأولوية ومستوى التصعيد واتفاقية مستوى الخدمة، وأضف كلمات مفتاحية مخصصة للذكاء الاصطناعي لنشاطك التجاري',
    'pcb.category.note': 'ملاحظة',
    'pcb.category.editNote': 'تنطبق التخصيصات على نشاطك التجاري فقط. تُحفظ إعدادات الفئة الأصلية.',
    'pcb.category.customPriority': 'أولوية مخصصة',
    'pcb.category.defaultLabel': 'الافتراضي',
    'pcb.category.useDefault': 'استخدام الافتراضي',
    'pcb.category.low': 'منخفضة',
    'pcb.category.medium': 'متوسطة',
    'pcb.category.high': 'عالية',
    'pcb.category.critical': 'حرجة',
    'pcb.category.leaveEmptyDefault': 'اتركه فارغًا لاستخدام الافتراضي',
    'pcb.category.customEscalation': 'مستوى تصعيد مخصص',
    'pcb.category.setEscalation': 'تعيين مستوى التصعيد',
    'pcb.category.customSlaHours': 'اتفاقية مستوى الخدمة المخصصة (ساعات)',
    'pcb.category.egSla24': 'مثال: 24',
    'pcb.category.slaHint': 'هدف زمن الاستجابة لهذه الفئة',
    'pcb.category.additionalKeywords': 'كلمات مفتاحية إضافية للذكاء الاصطناعي (مفصولة بفواصل)',
    'pcb.category.keywordsPlaceholder': 'مثال: عبارة مخصصة، مصطلح خاص بالنشاط، مصطلحات القطاع',
    'pcb.category.keywordsHint': 'أضف كلمات مفتاحية خاصة بنشاطك لمساعدة الذكاء الاصطناعي على تصنيف الملاحظات بشكل أفضل. تُضاف إلى الكلمات المفتاحية الافتراضية.',
    'pcb.category.defaultAiKeywords': 'الكلمات المفتاحية الافتراضية للذكاء الاصطناعي:',
    'pcb.category.saveCustomization': 'حفظ التخصيص',
    'pcb.category.createTitle': 'إنشاء فئة ملاحظات مخصصة',
    'pcb.category.createDesc': 'أضف فئة ملاحظات فريدة خاصة بنشاطك التجاري',
    'pcb.category.categoryName': 'اسم الفئة',
    'pcb.category.namePlaceholder': 'مثال: التعامل مع كبار الضيوف',
    'pcb.category.description': 'الوصف',
    'pcb.category.descPlaceholder': 'ما نوع الملاحظات التي تغطيها هذه الفئة؟',
    'pcb.category.priorityLevel': 'مستوى الأولوية',
    'pcb.category.escalateTo': 'التصعيد إلى',
    'pcb.category.slaHours': 'اتفاقية مستوى الخدمة (ساعات)',
    'pcb.category.aiKeywordsCsv': 'الكلمات المفتاحية للذكاء الاصطناعي (مفصولة بفواصل)',
    'pcb.category.keywordsPlaceholder2': 'مثال: كبار الشخصيات، ضيف مميز، طلب خاص، كونسيرج',
    'pcb.category.keywordsHint2': 'تساعد الكلمات المفتاحية الذكاء الاصطناعي على تصنيف الملاحظات ضمن هذه الفئة تلقائيًا',
    'pcb.category.createCategory': 'إنشاء الفئة',
    'pcb.category.customCreated': 'تم إنشاء الفئة المخصصة "{name}" بنجاح لنشاطك التجاري',
    'pcb.category.customRemoved': 'تمت إزالة الفئة المخصصة "{name}"',
    'pcb.category.confirmDelete': 'حذف الفئة المخصصة "{name}"؟ لا يمكن التراجع عن هذا الإجراء.',
    'pcb.category.cannotDelete': 'يتعذّر الحذف',
    'pcb.category.inheritedCannotDelete': 'يمكن فقط تعطيل الفئات الموروثة/العامة، ولا يمكن حذفها.',
    'pcb.category.cannotDeleteInherited': 'لا يمكن حذف الفئات الموروثة/العامة؛ قم بتعطيلها بدلاً من ذلك.',
    'pcb.category.notFound': 'الفئة غير موجودة (تمت إزالتها بالفعل).',
    'pcb.category.deleted': 'محذوفة',
    'pcb.category.categoryEnabled': 'تم تفعيل الفئة',
    'pcb.category.categoryDisabled': 'تم تعطيل الفئة',
    'pcb.category.failedSaveCustomization': 'فشل حفظ التخصيص',
    'pcb.category.failedCreateCustom': 'فشل إنشاء الفئة المخصصة',
    'pcb.category.failedUpdate': 'فشل تحديث الفئة',
    'pcb.category.failedDelete': 'فشل حذف الفئة',

    'pcb.director.noTicketActivity': 'لا يوجد نشاط تذاكر في الفترة المحددة.',
    'pcb.director.ticketStatusDist': 'توزيع حالة التذاكر',
    'pcb.director.noTicketData': 'لا توجد بيانات تذاكر في الفترة المحددة.',
    'pcb.director.conversationIntents': 'نوايا المحادثات',
    'pcb.director.noIntentData': 'لا تتوفر بعد بيانات عن نوايا المحادثات.',
    'pcb.director.customerSatisfaction': 'رضا العملاء',
    'pcb.director.responses': 'ردود',
    'pcb.director.aiAutoResolution': 'الحل التلقائي بالذكاء الاصطناعي',
    'pcb.director.resolvedWithoutStaff': 'تم حلها دون موظفين',
    'pcb.director.escalationRate': 'معدل التصعيد',
    'pcb.director.callbackRate': 'معدل معاودة الاتصال',
    'pcb.director.kpisTitle': 'مؤشرات الأداء الرئيسية',
    'pcb.director.avgResolutionTime': 'متوسط وقت الحل',
    'pcb.director.avgFirstResponseFull': 'متوسط الاستجابة الأولى',
    'pcb.director.reopenedTickets': 'التذاكر المُعاد فتحها',
    'pcb.director.reopenedConversations': 'المحادثات المُعاد فتحها',
    'pcb.director.openaiUsageRate': 'معدل استخدام OpenAI',
    'pcb.director.ofTickets': '{resolved} من {total} تذكرة',
    'pcb.director.periodDay': 'اليوم',
    'pcb.director.periodWeek': 'هذا الأسبوع',
    'pcb.director.periodMonth': 'هذا الشهر',
    'pcb.director.periodQuarter': 'هذا الربع',
    'pcb.director.periodYear': 'هذا العام',

    'pcb.exec.yourBusiness': 'نشاطك التجاري',
    'pcb.exec.ticketsRequiringHuman': 'التذاكر التي تتطلب تدخلاً بشريًا',
    'pcb.exec.tabOperations': 'العمليات',
    'pcb.exec.tabAiPerformance': 'أداء الذكاء الاصطناعي',
    'pcb.exec.tabVoiceChannel': 'قناة الصوت',
    'pcb.exec.tabServiceQuality': 'جودة الخدمة',
    'pcb.exec.activeTickets': 'التذاكر النشطة',
    'pcb.exec.openRightNow': 'مفتوحة الآن',
    'pcb.exec.totalTickets': 'إجمالي التذاكر',
    'pcb.exec.resolved': 'تم حلها',
    'pcb.exec.avgResolution': 'متوسط الحل',
    'pcb.exec.createClose': 'الإنشاء ← الإغلاق',
    'pcb.exec.avgFirstResponse': 'متوسط الاستجابة الأولى',
    'pcb.exec.firstReply': 'أول رد',
    'pcb.exec.avgChatDuration': 'متوسط مدة المحادثة',
    'pcb.exec.perResolvedConv': 'لكل محادثة تم حلها',
    'pcb.exec.callbackRate': 'معدل معاودة الاتصال',
    'pcb.exec.escalationsPendingCallback': 'تصعيدات بانتظار معاودة الاتصال',
    'pcb.exec.reopenedConversations': 'المحادثات المُعاد فتحها',
    'pcb.exec.requiredFollowup': 'متابعة مطلوبة بعد الحل',
    'pcb.exec.operatorEscalationDist': 'توزيع التصعيدات حسب المشغّل',
    'pcb.exec.assigned': 'مُسنَدة',
    'pcb.exec.aiConversations': 'محادثات الذكاء الاصطناعي',
    'pcb.exec.autoResolution': 'الحل التلقائي',
    'pcb.exec.avgAiConfidence': 'متوسط ثقة الذكاء الاصطناعي',
    'pcb.exec.openaiFallbackRate': 'معدل الرجوع إلى OpenAI',
    'pcb.exec.financialMetricsNote': 'تتطلب المقاييس المالية (الإيرادات، العائد على الاستثمار، القيمة الدائمة للعميل، الحصة السوقية) تكامل الفوترة. تواصل مع المسؤول لتهيئة مصادر بيانات الفوترة.',
    'pcb.exec.csatScore': 'درجة رضا العملاء (CSAT)',
    'pcb.exec.avgCustomerRating': 'متوسط تقييم العملاء (مقياس 1–5)',
    'pcb.exec.basedOnRatings': 'استنادًا إلى {count} تقييمًا من العملاء',
    'pcb.exec.noRatingsCollected': 'لم تُجمع تقييمات بعد — يقيّم العملاء بعد الحل',
    'pcb.exec.resolutionHealth': 'صحة الحل',
    'pcb.exec.aiResolvedNoHuman': 'تم الحل بالذكاء الاصطناعي دون تدخل بشري',
    'pcb.exec.ticketsResolvedOf': 'تم حل {resolved} من {total} تذكرة',
    'pcb.exec.noData': 'لا توجد بيانات',
    'pcb.exec.callbackSla': 'اتفاقية مستوى خدمة معاودة الاتصال',
    'pcb.exec.slaBreaches': 'خروقات اتفاقية مستوى الخدمة (معاودات اتصال متأخرة)',
    'pcb.exec.pendingOverdue': '{pending} قيد الانتظار، {overdue} متأخرة',
    'pcb.exec.noVoiceData': 'لا توجد بيانات صوتية',
    'pcb.exec.surveyMetricsNote': 'يتطلب صافي نقاط الترويج (NPS) ورضا الموظفين ومقاييس السوق تكاملات إضافية لبيانات الاستبيانات والسوق. وهي غير متاحة من البيانات التشغيلية وحدها.',
    'pcb.exec.responses': 'ردود',

    'pcb.it.recentEscalations': 'التصعيدات الأخيرة',
    'pcb.it.noRecentEscalations': 'لا توجد تصعيدات حديثة.',
    'pcb.it.manageIntegrations': 'إدارة عمليات التكامل في الإعدادات',
    'pcb.it.escalation': 'تصعيد',
    'pcb.it.justNow': 'الآن',
    'pcb.it.minAgo': 'قبل {n} دقيقة',
    'pcb.it.hourAgo': 'قبل {n} ساعة',
    'pcb.it.dayAgo': 'قبل {n} يوم',
  },
};

export default pagesCompleteBTranslations;
